import { PRIVILLEGED_ROLES, ROLES, config } from "./constant";
import _, { difference, inRange } from "lodash";

import { ChatConfigurtationActions } from "../store/slices/chat_configuration_slice/chat_configuration_slice";
import { ClearStorage, GetItemFromStorage, SetItemInStorage } from "../custom_hooks/useStorage";
import { CallServices, ConnectorService, CoreServices } from "./service/apiServices";
import { ChatState, InitialSetupState } from "./models/model";
import { LoginService } from "./service/loginService";
import { Types } from "./action/action";
import callChatService from "./service/chatService";
import jwt_decode from "jwt-decode";
import moment from "moment";
import { shortcutKeyActions } from "../store/slices/shortcutkeys_slice/shortcutkeys_slice";
import shortid from "shortid";
import store from "./store/store";
import { useNavigate } from "react-router-dom";
import { LocalStorage } from "../custom_hooks/localStorageKeys";
import { supervisorContactDataSliceActions } from '../store/slices/supervisor_contact/contactsData';
import { connectorsActions } from "../store/slices/connectors/connectors_slice";
import { notification } from "antd";
import stores from "../store/redux-store/root_store";
import axios from "axios";
import { ApiServices } from "../services/api_services";
import { CALLURL, COREURL } from "../constants/api_constants";
import { uuidv4 } from "../annotation";
import { dispositionSliceActions } from "../store/slices/dispositionSlice/postDisposition";
import { ChatActions } from "../store/slices/chat_slice/chat_slice";
import { useSelector } from "react-redux";
import { countryTimezones } from "../components/main_layout/navigation/settings/basic_configuration/business_hours/countryConstants";
import { queueTrackerActions } from "../store/slices/trackerStatus_slice/queueTrackerslice";
import { outboundCampaignSliceAction } from "../store/slices/outboundCampaign/outboundCampaignslice";
import { Cookies } from "../utils/cookies";
import { differenceInDays, format } from 'date-fns';
import { successNotify } from "./reportsAndAnalyticsUtils";


export class Cookie {
  static host = window.location.hostname;

  static set(name: any, value: any, days: any) {
    var domain, domainParts, date: any, expires;

    if (days) {
      date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    if (this.host.split(".").length === 1) {
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      domainParts = this.host.split(".");

      domainParts.shift();

      domain = domainParts.join(".");

      document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
    }
  }

  static get = () => {
    return document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce((accumulator, [key, value]) => {
        if (key.trim()) return { ...accumulator, [key.trim()]: decodeURIComponent(value) };
        else return "";
      }, {});
  };

  static clear = () => {
    const host = window.location.hostname;

    const domainParts = host.split(".");

    domainParts.shift();

    const domain = domainParts.join(".");

    document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "roleId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "stateChange=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "userDetials=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "workStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "userEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "MY_APP_STATE=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "agentExt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "RememberMe=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "ssoToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "dashboardTour=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
  };
}

export const determineIps = async () => {
  const pc = new RTCPeerConnection({
    iceServers: [{ urls: "stun:audioturnv4.worktual.co.uk:443" }],
  });
  await pc.createDataChannel("");
  await pc.createOffer().then((offer) => pc.setLocalDescription(offer));
  pc.onicecandidate = async (ice) => {
    if (!ice || !ice.candidate || !ice.candidate.candidate) {
      pc.close();
      return;
    }
    let split = ice.candidate.candidate.split(" ");
    if (split[7] === "host") {
      // logInfo(`Local IP : ${split[4]}`,'');
    } else {
      // logInfo(`External IP : ${split[4]}`,'');
      SetItemInStorage("IP", split[4]);
    }
  };
};


export const urlsplit = (url: any) => {

  const queryString = url.split('?')[1];
  const paramsArray = queryString.split('&');
  const params: any = {};

  paramsArray.forEach((param: any) => {
    const [key, value] = param.split('=');
    params[key] = value;
  });


  return ({ domainId: params['domainId'], channelTypeId: params['channelTypeId'], historyId: params['historyId'] })
}

export const customer: any = [
  "Profile ID",
  "First name",
  "Last name",
  "Position",
  "Customer Type",
  "Category",
  "Organization",
  "Website",
  "Address line",
  "City",
  "Zip_Postal Code",
  "Country",
  "State",
  "Email-Work",
  "Email-Personal",
  "Email-Others",
  "Phone-Work",
  "Phone-Personal",
  "Phone-Others",
  "Whatsapp",
  "Linked In",
  "Twitter",
  "Instagram",
  "Facebook",
  "Notes",
  "Product Interests",
  "Pain points",
  "Preferences",
];

export const system: any = [
  "Customer number",
  "Customer ID",
  "Dialed number",
  "Customer callback number",
  "Stored customer input",
  "Queue name",
  "Queue outbound number",
  "Contact id",
  "Initial Contact id",
  "Previous Contact id",
  "Channel",
  "Initiation method",
  "Language",
  "System Endpoint Type",
  "Queue Outbound Caller ID number",
  "Queue Outbound Caller ID number type",
  "Preferences",
];

export const agent: any = ["Agent User Name", "Agent First Name", "Agent Last Name"];

export const queue: any = [" Excalation Queue", "Qa test queue", "Check live call", "UMN queue", "Technical queue", "sales queue"];

export const timeZoneList: any = [
  {
    id: "Pacific/Niue",
    name: "(GMT-11:00) Niue",
  },
  {
    id: "Pacific/Pago_Pago",
    name: "(GMT-11:00) Pago Pago",
  },
  {
    id: "Pacific/Honolulu",
    name: "(GMT-10:00) Hawaii Time",
  },
  {
    id: "Pacific/Rarotonga",
    name: "(GMT-10:00) Rarotonga",
  },
  {
    id: "Pacific/Tahiti",
    name: "(GMT-10:00) Tahiti",
  },
  {
    id: "Pacific/Marquesas",
    name: "(GMT-09:30) Marquesas",
  },
  {
    id: "America/Anchorage",
    name: "(GMT-09:00) Alaska Time",
  },
  {
    id: "Pacific/Gambier",
    name: "(GMT-09:00) Gambier",
  },
  {
    id: "America/Los_Angeles",
    name: "(GMT-08:00) Pacific Time",
  },
  {
    id: "America/Tijuana",
    name: "(GMT-08:00) Pacific Time - Tijuana",
  },
  {
    id: "America/Vancouver",
    name: "(GMT-08:00) Pacific Time - Vancouver",
  },
  {
    id: "America/Whitehorse",
    name: "(GMT-08:00) Pacific Time - Whitehorse",
  },
  {
    id: "Pacific/Pitcairn",
    name: "(GMT-08:00) Pitcairn",
  },
  {
    id: "America/Dawson_Creek",
    name: "(GMT-07:00) Mountain Time - Dawson Creek",
  },
  {
    id: "America/Denver",
    name: "(GMT-07:00) Mountain Time",
  },
  {
    id: "America/Edmonton",
    name: "(GMT-07:00) Mountain Time - Edmonton",
  },
  {
    id: "America/Hermosillo",
    name: "(GMT-07:00) Mountain Time - Hermosillo",
  },
  {
    id: "America/Mazatlan",
    name: "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan",
  },
  {
    id: "America/Phoenix",
    name: "(GMT-07:00) Mountain Time - Arizona",
  },
  {
    id: "America/Yellowknife",
    name: "(GMT-07:00) Mountain Time - Yellowknife",
  },
  {
    id: "America/Belize",
    name: "(GMT-06:00) Belize",
  },
  {
    id: "America/Chicago",
    name: "(GMT-06:00) Central Time",
  },
  {
    id: "America/Costa_Rica",
    name: "(GMT-06:00) Costa Rica",
  },
  {
    id: "America/El_Salvador",
    name: "(GMT-06:00) El Salvador",
  },
  {
    id: "America/Guatemala",
    name: "(GMT-06:00) Guatemala",
  },
  {
    id: "America/Managua",
    name: "(GMT-06:00) Managua",
  },
  {
    id: "America/Mexico_City",
    name: "(GMT-06:00) Central Time - Mexico City",
  },
  {
    id: "America/Regina",
    name: "(GMT-06:00) Central Time - Regina",
  },
  {
    id: "America/Tegucigalpa",
    name: "(GMT-06:00) Central Time - Tegucigalpa",
  },
  {
    id: "America/Winnipeg",
    name: "(GMT-06:00) Central Time - Winnipeg",
  },
  {
    id: "Pacific/Galapagos",
    name: "(GMT-06:00) Galapagos",
  },
  {
    id: "America/Bogota",
    name: "(GMT-05:00) Bogota",
  },
  {
    id: "America/Cancun",
    name: "(GMT-05:00) America Cancun",
  },
  {
    id: "America/Cayman",
    name: "(GMT-05:00) Cayman",
  },
  {
    id: "America/Guayaquil",
    name: "(GMT-05:00) Guayaquil",
  },
  {
    id: "America/Havana",
    name: "(GMT-05:00) Havana",
  },
  {
    id: "America/Iqaluit",
    name: "(GMT-05:00) Eastern Time - Iqaluit",
  },
  {
    id: "America/Jamaica",
    name: "(GMT-05:00) Jamaica",
  },
  {
    id: "America/Lima",
    name: "(GMT-05:00) Lima",
  },
  {
    id: "America/Nassau",
    name: "(GMT-05:00) Nassau",
  },
  {
    id: "America/New_York",
    name: "(GMT-05:00) Eastern Time",
  },
  {
    id: "America/Panama",
    name: "(GMT-05:00) Panama",
  },
  {
    id: "America/Port-au-Prince",
    name: "(GMT-05:00) Port-au-Prince",
  },
  {
    id: "America/Rio_Branco",
    name: "(GMT-05:00) Rio Branco",
  },
  {
    id: "America/Toronto",
    name: "(GMT-05:00) Eastern Time - Toronto",
  },
  {
    id: "Pacific/Easter",
    name: "(GMT-05:00) Easter Island",
  },
  {
    id: "America/Caracas",
    name: "(GMT-04:30) Caracas",
  },
  {
    id: "America/Asuncion",
    name: "(GMT-03:00) Asuncion",
  },
  {
    id: "America/Barbados",
    name: "(GMT-04:00) Barbados",
  },
  {
    id: "America/Boa_Vista",
    name: "(GMT-04:00) Boa Vista",
  },
  {
    id: "America/Campo_Grande",
    name: "(GMT-03:00) Campo Grande",
  },
  {
    id: "America/Cuiaba",
    name: "(GMT-03:00) Cuiaba",
  },
  {
    id: "America/Curacao",
    name: "(GMT-04:00) Curacao",
  },
  {
    id: "America/Grand_Turk",
    name: "(GMT-04:00) Grand Turk",
  },
  {
    id: "America/Guyana",
    name: "(GMT-04:00) Guyana",
  },
  {
    id: "America/Halifax",
    name: "(GMT-04:00) Atlantic Time - Halifax",
  },
  {
    id: "America/La_Paz",
    name: "(GMT-04:00) La Paz",
  },
  {
    id: "America/Manaus",
    name: "(GMT-04:00) Manaus",
  },
  {
    id: "America/Martinique",
    name: "(GMT-04:00) Martinique",
  },
  {
    id: "America/Port_of_Spain",
    name: "(GMT-04:00) Port of Spain",
  },
  {
    id: "America/Porto_Velho",
    name: "(GMT-04:00) Porto Velho",
  },
  {
    id: "America/Puerto_Rico",
    name: "(GMT-04:00) Puerto Rico",
  },
  {
    id: "America/Santo_Domingo",
    name: "(GMT-04:00) Santo Domingo",
  },
  {
    id: "America/Thule",
    name: "(GMT-04:00) Thule",
  },
  {
    id: "Atlantic/Bermuda",
    name: "(GMT-04:00) Bermuda",
  },
  {
    id: "America/St_Johns",
    name: "(GMT-03:30) Newfoundland Time - St. Johns",
  },
  {
    id: "America/Araguaina",
    name: "(GMT-03:00) Araguaina",
  },
  {
    id: "America/Argentina/Buenos_Aires",
    name: "(GMT-03:00) Buenos Aires",
  },
  {
    id: "America/Bahia",
    name: "(GMT-03:00) Salvador",
  },
  {
    id: "America/Belem",
    name: "(GMT-03:00) Belem",
  },
  {
    id: "America/Cayenne",
    name: "(GMT-03:00) Cayenne",
  },
  {
    id: "America/Fortaleza",
    name: "(GMT-03:00) Fortaleza",
  },
  {
    id: "America/Godthab",
    name: "(GMT-03:00) Godthab",
  },
  {
    id: "America/Maceio",
    name: "(GMT-03:00) Maceio",
  },
  {
    id: "America/Miquelon",
    name: "(GMT-03:00) Miquelon",
  },
  {
    id: "America/Montevideo",
    name: "(GMT-03:00) Montevideo",
  },
  {
    id: "America/Paramaribo",
    name: "(GMT-03:00) Paramaribo",
  },
  {
    id: "America/Recife",
    name: "(GMT-03:00) Recife",
  },
  {
    id: "America/Santiago",
    name: "(GMT-03:00) Santiago",
  },
  {
    id: "America/Sao_Paulo",
    name: "(GMT-02:00) Sao Paulo",
  },
  {
    id: "Antarctica/Palmer",
    name: "(GMT-03:00) Palmer",
  },
  {
    id: "Antarctica/Rothera",
    name: "(GMT-03:00) Rothera",
  },
  {
    id: "Atlantic/Stanley",
    name: "(GMT-03:00) Stanley",
  },
  {
    id: "America/Noronha",
    name: "(GMT-02:00) Noronha",
  },
  {
    id: "Atlantic/South_Georgia",
    name: "(GMT-02:00) South Georgia",
  },
  {
    id: "America/Scoresbysund",
    name: "(GMT-01:00) Scoresbysund",
  },
  {
    id: "Atlantic/Azores",
    name: "(GMT-01:00) Azores",
  },
  {
    id: "Atlantic/Cape_Verde",
    name: "(GMT-01:00) Cape Verde",
  },
  {
    id: "Africa/Abidjan",
    name: "(GMT+00:00) Abidjan",
  },
  {
    id: "Africa/Accra",
    name: "(GMT+00:00) Accra",
  },
  {
    id: "Africa/Bissau",
    name: "(GMT+00:00) Bissau",
  },
  {
    id: "Africa/Casablanca",
    name: "(GMT+00:00) Casablanca",
  },
  {
    id: "Africa/El_Aaiun",
    name: "(GMT+00:00) El Aaiun",
  },
  {
    id: "Africa/Monrovia",
    name: "(GMT+00:00) Monrovia",
  },
  {
    id: "America/Danmarkshavn",
    name: "(GMT+00:00) Danmarkshavn",
  },
  {
    id: "Atlantic/Canary",
    name: "(GMT+00:00) Canary Islands",
  },
  {
    id: "Atlantic/Faroe",
    name: "(GMT+00:00) Faeroe",
  },
  {
    id: "Atlantic/Reykjavik",
    name: "(GMT+00:00) Reykjavik",
  },
  {
    id: "Etc/GMT",
    name: "(GMT+00:00) GMT (no daylight saving)",
  },
  {
    id: "Europe/Dublin",
    name: "(GMT+00:00) Dublin",
  },
  {
    id: "Europe/Lisbon",
    name: "(GMT+00:00) Lisbon",
  },
  {
    id: "Europe/London",
    name: "(GMT+00:00) London",
  },
  {
    id: "Africa/Algiers",
    name: "(GMT+01:00) Algiers",
  },
  {
    id: "Africa/Ceuta",
    name: "(GMT+01:00) Ceuta",
  },
  {
    id: "Africa/Lagos",
    name: "(GMT+01:00) Lagos",
  },
  {
    id: "Africa/Ndjamena",
    name: "(GMT+01:00) Ndjamena",
  },
  {
    id: "Africa/Tunis",
    name: "(GMT+01:00) Tunis",
  },
  {
    id: "Africa/Windhoek",
    name: "(GMT+02:00) Windhoek",
  },
  {
    id: "Europe/Amsterdam",
    name: "(GMT+01:00) Amsterdam",
  },
  {
    id: "Europe/Andorra",
    name: "(GMT+01:00) Andorra",
  },
  {
    id: "Europe/Belgrade",
    name: "(GMT+01:00) Central European Time - Belgrade",
  },
  {
    id: "Europe/Berlin",
    name: "(GMT+01:00) Berlin",
  },
  {
    id: "Europe/Brussels",
    name: "(GMT+01:00) Brussels",
  },
  {
    id: "Europe/Budapest",
    name: "(GMT+01:00) Budapest",
  },
  {
    id: "Europe/Copenhagen",
    name: "(GMT+01:00) Copenhagen",
  },
  {
    id: "Europe/Gibraltar",
    name: "(GMT+01:00) Gibraltar",
  },
  {
    id: "Europe/Luxembourg",
    name: "(GMT+01:00) Luxembourg",
  },
  {
    id: "Europe/Madrid",
    name: "(GMT+01:00) Madrid",
  },
  {
    id: "Europe/Malta",
    name: "(GMT+01:00) Malta",
  },
  {
    id: "Europe/Monaco",
    name: "(GMT+01:00) Monaco",
  },
  {
    id: "Europe/Oslo",
    name: "(GMT+01:00) Oslo",
  },
  {
    id: "Europe/Paris",
    name: "(GMT+01:00) Paris",
  },
  {
    id: "Europe/Prague",
    name: "(GMT+01:00) Central European Time - Prague",
  },
  {
    id: "Europe/Rome",
    name: "(GMT+01:00) Rome",
  },
  {
    id: "Europe/Stockholm",
    name: "(GMT+01:00) Stockholm",
  },
  {
    id: "Europe/Tirane",
    name: "(GMT+01:00) Tirane",
  },
  {
    id: "Europe/Vienna",
    name: "(GMT+01:00) Vienna",
  },
  {
    id: "Europe/Warsaw",
    name: "(GMT+01:00) Warsaw",
  },
  {
    id: "Europe/Zurich",
    name: "(GMT+01:00) Zurich",
  },
  {
    id: "Africa/Cairo",
    name: "(GMT+02:00) Cairo",
  },
  {
    id: "Africa/Johannesburg",
    name: "(GMT+02:00) Johannesburg",
  },
  {
    id: "Africa/Maputo",
    name: "(GMT+02:00) Maputo",
  },
  {
    id: "Africa/Tripoli",
    name: "(GMT+02:00) Tripoli",
  },
  {
    id: "Asia/Amman",
    name: "(GMT+02:00) Amman",
  },
  {
    id: "Asia/Beirut",
    name: "(GMT+02:00) Beirut",
  },
  {
    id: "Asia/Damascus",
    name: "(GMT+02:00) Damascus",
  },
  {
    id: "Asia/Gaza",
    name: "(GMT+02:00) Gaza",
  },
  {
    id: "Asia/Jerusalem",
    name: "(GMT+02:00) Jerusalem",
  },
  {
    id: "Asia/Nicosia",
    name: "(GMT+02:00) Nicosia",
  },
  {
    id: "Europe/Athens",
    name: "(GMT+02:00) Athens",
  },
  {
    id: "Europe/Bucharest",
    name: "(GMT+02:00) Bucharest",
  },
  {
    id: "Europe/Chisinau",
    name: "(GMT+02:00) Chisinau",
  },
  {
    id: "Europe/Helsinki",
    name: "(GMT+02:00) Helsinki",
  },
  {
    id: "Europe/Istanbul",
    name: "(GMT+02:00) Istanbul",
  },
  {
    id: "Europe/Kaliningrad",
    name: "(GMT+02:00) Moscow-01 - Kaliningrad",
  },
  {
    id: "Europe/Kiev",
    name: "(GMT+02:00) Kiev",
  },
  {
    id: "Europe/Riga",
    name: "(GMT+02:00) Riga",
  },
  {
    id: "Europe/Sofia",
    name: "(GMT+02:00) Sofia",
  },
  {
    id: "Europe/Tallinn",
    name: "(GMT+02:00) Tallinn",
  },
  {
    id: "Europe/Vilnius",
    name: "(GMT+02:00) Vilnius",
  },
  {
    id: "Africa/Khartoum",
    name: "(GMT+03:00) Khartoum",
  },
  {
    id: "Africa/Nairobi",
    name: "(GMT+03:00) Nairobi",
  },
  {
    id: "Antarctica/Syowa",
    name: "(GMT+03:00) Syowa",
  },
  {
    id: "Asia/Baghdad",
    name: "(GMT+03:00) Baghdad",
  },
  {
    id: "Asia/Qatar",
    name: "(GMT+03:00) Qatar",
  },
  {
    id: "Asia/Riyadh",
    name: "(GMT+03:00) Riyadh",
  },
  {
    id: "Europe/Minsk",
    name: "(GMT+03:00) Minsk",
  },
  {
    id: "Europe/Moscow",
    name: "(GMT+03:00) Moscow+00 - Moscow",
  },
  {
    id: "Asia/Tehran",
    name: "(GMT+03:30) Tehran",
  },
  {
    id: "Asia/Baku",
    name: "(GMT+04:00) Baku",
  },
  {
    id: "Asia/Dubai",
    name: "(GMT+04:00) Dubai",
  },
  {
    id: "Asia/Tbilisi",
    name: "(GMT+04:00) Tbilisi",
  },
  {
    id: "Asia/Yerevan",
    name: "(GMT+04:00) Yerevan",
  },
  {
    id: "Europe/Samara",
    name: "(GMT+04:00) Moscow+01 - Samara",
  },
  {
    id: "Indian/Mahe",
    name: "(GMT+04:00) Mahe",
  },
  {
    id: "Indian/Mauritius",
    name: "(GMT+04:00) Mauritius",
  },
  {
    id: "Indian/Reunion",
    name: "(GMT+04:00) Reunion",
  },
  {
    id: "Asia/Kabul",
    name: "(GMT+04:30) Kabul",
  },
  {
    id: "Antarctica/Mawson",
    name: "(GMT+05:00) Mawson",
  },
  {
    id: "Asia/Aqtau",
    name: "(GMT+05:00) Aqtau",
  },
  {
    id: "Asia/Aqtobe",
    name: "(GMT+05:00) Aqtobe",
  },
  {
    id: "Asia/Ashgabat",
    name: "(GMT+05:00) Ashgabat",
  },
  {
    id: "Asia/Dushanbe",
    name: "(GMT+05:00) Dushanbe",
  },
  {
    id: "Asia/Karachi",
    name: "(GMT+05:00) Karachi",
  },
  {
    id: "Asia/Tashkent",
    name: "(GMT+05:00) Tashkent",
  },
  {
    id: "Asia/Yekaterinburg",
    name: "(GMT+05:00) Moscow+02 - Yekaterinburg",
  },
  {
    id: "Indian/Kerguelen",
    name: "(GMT+05:00) Kerguelen",
  },
  {
    id: "Indian/Maldives",
    name: "(GMT+05:00) Maldives",
  },
  {
    id: "Asia/Kolkata",
    name: "(GMT+05:30) India Standard Time",
  },
  {
    id: "Asia/Colombo",
    name: "(GMT+05:30) Colombo",
  },
  {
    id: "Asia/Katmandu",
    name: "(GMT+05:45) Katmandu",
  },
  {
    id: "Antarctica/Vostok",
    name: "(GMT+06:00) Vostok",
  },
  {
    id: "Asia/Almaty",
    name: "(GMT+06:00) Almaty",
  },
  {
    id: "Asia/Bishkek",
    name: "(GMT+06:00) Bishkek",
  },
  {
    id: "Asia/Dhaka",
    name: "(GMT+06:00) Dhaka",
  },
  {
    id: "Asia/Omsk",
    name: "(GMT+06:00) Moscow+03 - Omsk, Novosibirsk",
  },
  {
    id: "Asia/Thimphu",
    name: "(GMT+06:00) Thimphu",
  },
  {
    id: "Indian/Chagos",
    name: "(GMT+06:00) Chagos",
  },
  {
    id: "Asia/Rangoon",
    name: "(GMT+06:30) Rangoon",
  },
  {
    id: "Indian/Cocos",
    name: "(GMT+06:30) Cocos",
  },
  {
    id: "Antarctica/Davis",
    name: "(GMT+07:00) Davis",
  },
  {
    id: "Asia/Bangkok",
    name: "(GMT+07:00) Bangkok",
  },
  {
    id: "Asia/Hovd",
    name: "(GMT+07:00) Hovd",
  },
  {
    id: "Asia/Jakarta",
    name: "(GMT+07:00) Jakarta",
  },
  {
    id: "Asia/Krasnoyarsk",
    name: "(GMT+07:00) Moscow+04 - Krasnoyarsk",
  },
  {
    id: "Asia/Saigon",
    name: "(GMT+07:00) Hanoi",
  },
  {
    id: "Indian/Christmas",
    name: "(GMT+07:00) Christmas",
  },
  {
    id: "Antarctica/Casey",
    name: "(GMT+08:00) Casey",
  },
  {
    id: "Asia/Brunei",
    name: "(GMT+08:00) Brunei",
  },
  {
    id: "Asia/Choibalsan",
    name: "(GMT+08:00) Choibalsan",
  },
  {
    id: "Asia/Hong_Kong",
    name: "(GMT+08:00) Hong Kong",
  },
  {
    id: "Asia/Irkutsk",
    name: "(GMT+08:00) Moscow+05 - Irkutsk",
  },
  {
    id: "Asia/Kuala_Lumpur",
    name: "(GMT+08:00) Kuala Lumpur",
  },
  {
    id: "Asia/Macau",
    name: "(GMT+08:00) Macau",
  },
  {
    id: "Asia/Makassar",
    name: "(GMT+08:00) Makassar",
  },
  {
    id: "Asia/Manila",
    name: "(GMT+08:00) Manila",
  },
  {
    id: "Asia/Shanghai",
    name: "(GMT+08:00) China Time - Beijing",
  },
  {
    id: "Asia/Singapore",
    name: "(GMT+08:00) Singapore",
  },
  {
    id: "Asia/Taipei",
    name: "(GMT+08:00) Taipei",
  },
  {
    id: "Asia/Ulaanbaatar",
    name: "(GMT+08:00) Ulaanbaatar",
  },
  {
    id: "Australia/Perth",
    name: "(GMT+08:00) Western Time - Perth",
  },
  {
    id: "Asia/Pyongyang",
    name: "(GMT+08:30) Pyongyang",
  },
  {
    id: "Asia/Dili",
    name: "(GMT+09:00) Dili",
  },
  {
    id: "Asia/Jayapura",
    name: "(GMT+09:00) Jayapura",
  },
  {
    id: "Asia/Seoul",
    name: "(GMT+09:00) Seoul",
  },
  {
    id: "Asia/Tokyo",
    name: "(GMT+09:00) Tokyo",
  },
  {
    id: "Asia/Yakutsk",
    name: "(GMT+09:00) Moscow+06 - Yakutsk",
  },
  {
    id: "Pacific/Palau",
    name: "(GMT+09:00) Palau",
  },
  {
    id: "Australia/Adelaide",
    name: "(GMT+10:30) Central Time - Adelaide",
  },
  {
    id: "Australia/Darwin",
    name: "(GMT+09:30) Central Time - Darwin",
  },
  {
    id: "Antarctica/DumontDUrville",
    name: "(GMT+10:00) Dumont D'Urville",
  },
  {
    id: "Asia/Magadan",
    name: "(GMT+10:00) Moscow+07 - Magadan",
  },
  {
    id: "Asia/Vladivostok",
    name: "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk",
  },
  {
    id: "Australia/Brisbane",
    name: "(GMT+10:00) Eastern Time - Brisbane",
  },
  {
    id: "Australia/Hobart",
    name: "(GMT+11:00) Eastern Time - Hobart",
  },
  {
    id: "Australia/Sydney",
    name: "(GMT+11:00) Eastern Time - Melbourne, Sydney",
  },
  {
    id: "Pacific/Chuuk",
    name: "(GMT+10:00) Truk",
  },
  {
    id: "Pacific/Guam",
    name: "(GMT+10:00) Guam",
  },
  {
    id: "Pacific/Port_Moresby",
    name: "(GMT+10:00) Port Moresby",
  },
  {
    id: "Pacific/Efate",
    name: "(GMT+11:00) Efate",
  },
  {
    id: "Pacific/Guadalcanal",
    name: "(GMT+11:00) Guadalcanal",
  },
  {
    id: "Pacific/Kosrae",
    name: "(GMT+11:00) Kosrae",
  },
  {
    id: "Pacific/Norfolk",
    name: "(GMT+11:00) Norfolk",
  },
  {
    id: "Pacific/Noumea",
    name: "(GMT+11:00) Noumea",
  },
  {
    id: "Pacific/Pohnpei",
    name: "(GMT+11:00) Ponape",
  },
  {
    id: "Asia/Kamchatka",
    name: "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy",
  },
  {
    id: "Pacific/Auckland",
    name: "(GMT+13:00) Auckland",
  },
  {
    id: "Pacific/Fiji",
    name: "(GMT+13:00) Fiji",
  },
  {
    id: "Pacific/Funafuti",
    name: "(GMT+12:00) Funafuti",
  },
  {
    id: "Pacific/Kwajalein",
    name: "(GMT+12:00) Kwajalein",
  },
  {
    id: "Pacific/Majuro",
    name: "(GMT+12:00) Majuro",
  },
  {
    id: "Pacific/Nauru",
    name: "(GMT+12:00) Nauru",
  },
  {
    id: "Pacific/Tarawa",
    name: "(GMT+12:00) Tarawa",
  },
  {
    id: "Pacific/Wake",
    name: "(GMT+12:00) Wake",
  },
  {
    id: "Pacific/Wallis",
    name: "(GMT+12:00) Wallis",
  },
  {
    id: "Pacific/Apia",
    name: "(GMT+14:00) Apia",
  },
  {
    id: "Pacific/Enderbury",
    name: "(GMT+13:00) Enderbury",
  },
  {
    id: "Pacific/Fakaofo",
    name: "(GMT+13:00) Fakaofo",
  },
  {
    id: "Pacific/Tongatapu",
    name: "(GMT+13:00) Tongatapu",
  },
  {
    id: "Pacific/Kiritimati",
    name: "(GMT+14:00) Kiritimati",
  },
  {
    id: "Africa/Addis_Ababa",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Bamako",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Bangui",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Banjul",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Blantyre",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Brazzaville",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Bujumbura",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Asia/Oral",
    name: "(UTC+05:00) Ashgabat, Tashkent",
  },
  {
    id: "Africa/Conakry",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Dakar",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Dar_es_Salaam",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Douala",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Freetown",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Gaborone",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Harare",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Juba",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Kampala",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Kinshasa",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Libreville",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Lome",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Kigali",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Luanda",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Lubumbashi",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Lusaka",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Malabo",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Mbabane",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Mogadishu",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Maseru",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Niamey",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Nouakchott",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Ouagadougou",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Porto-Novo",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "America/Argentina/Salta",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/La_Rioja",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/Rio_Gallegos",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/San_Juan",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/San_Luis",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/Tucuman",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/Ushuaia",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Bahia_Banderas",
    name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  },
  {
    id: "America/Blanc-Sablon",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/Boise",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Cambridge_Bay",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Cambridge_Bay",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Chihuahua",
    name: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  },
  {
    id: "America/Coral_Harbour",
    name: "(UTC-05:00) Bogota, Lima, Quito",
  },
  {
    id: "America/Creston",
    name: "(UTC-07:00) Arizona",
  },
  {
    id: "America/Detroit",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Detroit",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Dominica",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/Eirunepe",
    name: "(UTC-05:00) Bogota, Lima, Quito",
  },
  {
    id: "America/Glace_Bay",
    name: "(UTC-04:00) Atlantic Time (Canada)",
  },
  {
    id: "America/Goose_Bay",
    name: "(UTC-04:00) Atlantic Time (Canada)",
  },
  {
    id: "America/Indiana/Knox",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Indiana/Vincennes",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Indiana/Winamac",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Inuvik",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Juneau",
    name: "(UTC-09:00) Alaska",
  },
  {
    id: "America/Kentucky/Monticello",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Kralendijk",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/Matamoros",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Menominee",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Merida",
    name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  },
  {
    id: "America/Moncton",
    name: "(UTC-04:00) Atlantic Time (Canada)",
  },
  {
    id: "America/Monterrey",
    name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  },
  {
    id: "America/Montreal",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Nome",
    name: "(UTC-09:00) Alaska",
  },
  {
    id: "America/North_Dakota/Beulah",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/North_Dakota/Center",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/North_Dakota/New_Salem",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Ojinaga",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Pangnirtung",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Rankin_Inlet",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Rankin_Inlet",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Resolute",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Santa_Isabel",
    name: "(UTC-08:00) Baja California",
  },
  {
    id: "America/Santarem",
    name: "(UTC-03:00) Cayenne, Fortaleza",
  },
  {
    id: "America/Sitka",
    name: "(UTC-09:00) Alaska",
  },
  {
    id: "America/St_Lucia",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/St_Vincent",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "Arctic/Longyearbyen",
    name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    id: "Asia/Aden",
    name: "(UTC+03:00) Kuwait, Riyadh",
  },
  {
    id: "Asia/Anadyr",
    name: "(UTC+12:00) Magadan",
  },
  {
    id: "Asia/Kathmandu",
    name: "(UTC+05:45) Kathmandu",
  },
  {
    id: "Asia/Kuching",
    name: "(UTC+08:00) Kuala Lumpur, Singapore",
  },
  {
    id: "Asia/Muscat",
    name: "(UTC+04:00) Abu Dhabi, Muscat",
  },
  {
    id: "Asia/Novokuznetsk",
    name: "(UTC+07:00) Novosibirsk",
  },
  {
    id: "Asia/Novosibirsk",
    name: "(UTC+07:00) Novosibirsk",
  },
  {
    id: "Asia/Phnom_Penh",
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  },
  {
    id: "Asia/Pontianak",
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  },
  {
    id: "Asia/Qyzylorda",
    name: "(UTC+06:00) Nur-Sultan (Astana)",
  },
  {
    id: "Asia/Sakhalin",
    name: "(UTC+11:00) Vladivostok",
  },
  {
    id: "Asia/Samarkand",
    name: "(UTC+05:00) Ashgabat, Tashkent",
  },
  {
    id: "Asia/Urumqi",
    name: "(UTC+06:00) Nur-Sultan (Astana)",
  },
  {
    id: "Asia/Vientiane",
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  },
  {
    id: "Atlantic/Madeira",
    name: "(UTC) Dublin, Lisbon",
  },
  {
    id: "Atlantic/St_Helena",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Australia/Broken_Hill",
    name: "(UTC+09:30) Adelaide",
  },
  {
    id: "Australia/Melbourne",
    name: "(UTC+10:00) Canberra, Melbourne, Sydney",
  },
  {
    id: "Europe/Bratislava",
    name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    id: "Europe/Isle_of_Man",
    name: "(UTC) Edinburgh, London",
  },
  {
    id: "Europe/Isle_of_Man",
    name: "(UTC+01:00) Edinburgh, London",
  },
  {
    id: "Europe/Ljubljana",
    name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    id: "Europe/Podgorica",
    name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    id: "Europe/Sarajevo",
    name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    id: "Europe/Simferopol",
    name: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
  },
  {
    id: "Europe/Skopje",
    name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    id: "Europe/Uzhgorod",
    name: "(UTC+02:00) E. Europe",
  },
  {
    id: "Europe/Uzhgorod",
    name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  {
    id: "Europe/Vaduz",
    name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    id: "Europe/Volgograd",
    name: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
  },
  {
    id: "Europe/Zagreb",
    name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    id: "Europe/Zaporozhye",
    name: "(UTC+02:00) E. Europe",
  },
  {
    id: "Europe/Zaporozhye",
    name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  {
    id: "Indian/Antananarivo",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Indian/Comoro",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Indian/Mayotte",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Pacific/Johnston",
    name: "(UTC-10:00) Hawaii",
  },
  {
    id: "Pacific/Midway",
    name: "(UTC-11:00) Coordinated Universal Time-11",
  },
  {
    id: "Pacific/Saipan",
    name: "(UTC+10:00) Guam, Port Moresby",
  },
];

export const dialPadChanges = (iscall: boolean, userAgent: any, isAttended: any, isCallHold: any, isCallMute: any, isCallEnded: any, isTransfer: any) => {
  store.dispatch({
    type: Types.DIAL_PAD_CHANGES,
    payload: {
      isCallAccepted: iscall,
      dialedUserAgent: userAgent,
      isAttended: isAttended,
      isCallHold: isCallHold,
      isCallMute: isCallMute,
      isCallEnded: isCallEnded,
      isTransfer: isTransfer,
    },
  });
};

export const storeUserAgent = (UA: any, sucess: any) => {
  store.dispatch({
    type: Types.USER_AGENT_REDUCER,
    payload: {
      userAgent: UA,
      isSuccess: sucess,
    },
  });
};

export const getToken = () => {
  return document.cookie
    .split(";")
    .map((cookie) => cookie.split("="))
    .reduce(
      (accumulator, [key, value]) => ({
        ...accumulator,
        [key.trim()]: decodeURIComponent(value),
      }),
      {}
    );
};

export function encryptCodes(content: any, passcode: any) {
  var result: any = [];
  var passLen = passcode.length;

  for (var i = 0; i < content.length; i++) {
    var passOffset = i % passLen;

    var calAscii = content.charCodeAt(i) + passcode.charCodeAt(passOffset);

    result.push(calAscii);
  }

  return JSON.stringify(result);
}

export function decryptCodes(content: any, passcode: any) {
  let result: any = [];
  var str = "";

  var codesArr = JSON.parse(content);
  var passLen = passcode.length;

  for (var i = 0; i < codesArr.length; i++) {
    var passOffset = i % passLen;

    let calAscii: any = codesArr[i] - passcode.charCodeAt(passOffset);

    result.push(calAscii);
  }

  for (var j = 0; j < result.length; j++) {
    var ch = String.fromCharCode(result[j]);
    str += ch;
  }

  return str;
}

export const SignOut = () => {
  const navigate = useNavigate();
  Cookie.clear();
  navigate("/login");
  ClearStorage();

  // localStorage.clear();
  // sessionStorage.clear();
};

export const getChannelsList = () => {
  // const token: any = Cookie.get();
  // let LoginUserDetails: any = token["accessToken"] && token["accessToken"] && jwt_decode(token["accessToken"]);

  CoreServices.get(`/channel_get`).then((value: any) => {
    if (value && value.data.statusCode === 200) {
      return value.data.getchannelList[0];
    }
  });
};
export function groupbyday(data: any) {
  const groups =
    data &&
    data.reduce((groups: any, game: any) => {
      let date: any = get_recent_date(game.updatedAt);

      date = date.split(" ");
      date = date[4];
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(game);
      return groups;
    }, {});

  const groupArrays = Object.keys(groups).map((date) => {
    return {
      date,
      sessionData: groups[date],
    };
  });

  return groupArrays;
}

export function groupbydayForAssign(data: any) {
  const groups =
    data &&
    data.reduce((groups: any, game: any) => {
      let date: any = get_recent_date(game.updatedAt);

      date = date.split(" ");
      date = date[4];
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(game);
      return groups;
    }, {});
  const groupArrays = Object.keys(groups).map((date) => {
    return {
      date,
      sessionData: groups[date],
    };
  });
  return groupArrays;
}

export function get_recent_date(stamp: any) {
  let day: any = new Date(stamp);
  let min = day.getMinutes().toString().padStart(2, "0");
  let Bdate = day.getHours() + ":" + min;

  let time: any = Bdate.split(" ");
  let ampm: any;

  let [hours, minutes] = time[0].split(":");
  ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  time = hours + ":" + minutes + " " + ampm;

  let month: any = parseInt(day.getMonth()) + 1;
  let date = day.getDate().toString().length > 1 ? day.getDate() : "0" + day.getDate();
  month = month.toString().length > 1 ? month : "0" + month;
  let year = day.getFullYear();
  let newdate = date + "/" + month + "/" + year;

  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  var curDate = new Date();
  var Cdate = curDate.getDate() + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
  var Ydate = curDate.getDate() - 1 + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
  var Tdate = day.getDate() + "-" + (day.getMonth() + 1) + "-" + day.getFullYear();
  var group = Tdate;
  if (Cdate === Tdate) group = "Today";
  else if (Ydate === Tdate) group = "Yesterday";

  return days[day.getDay()] + " " + newdate + " " + time + " " + group;
}

export const startCallTime = (guid: string) => {
  let currentCallList: any[] = store.getState().callUserDetails.callDetails || [];
  let index: number = currentCallList.findIndex((e: any) => e.guid === guid);
  if (index !== -1) {
    let timer: any;
    timer = setInterval(() => {
      CallTimer(currentCallList, guid);
    }, 1000);

    currentCallList[index].timer = timer;
  }
};

export const CallTimer = (currentCallList: any[], guid: string) => {
  let incomingDetails: any = store.getState().callUserDetails || {};
  try {
    let index: number = currentCallList.findIndex((e: any) => e.guid === guid);
    let ltime: string = currentCallList[index].callduration || "";
    ltime = ltime ? ltime : "00:00:00";
    let ss: any = ltime.split(":");
    let dt = new Date();
    dt.setHours(ss[0]);
    dt.setMinutes(ss[1]);
    dt.setSeconds(ss[2]);
    let dt2 = new Date(dt.valueOf() + 1000);
    let temp = dt2.toTimeString().split(" ");
    let ts = temp[0].split(":");
    let timer: any;
    timer = ts[0] + ":" + ts[1] + ":" + ts[2];
    currentCallList[index].callduration = timer;
    incomingDetails.incomingCallDetail.callduration = timer;

    // store.dispatch(
    //   CallUserDetailsActions.updateConferenceUserLists({
    //     callDetails: currentCallList,
    //   })
    // );
    // store.dispatch(
    //   CallUserDetailsActions.updateIncomingCallPopup({
    //     incomingCallDetail: incomingDetails.incomingCallDetail,
    //   })
    // );

    // store.dispatch({
    //   type: Types.CONFERENCE_USER_LIST,
    //   payload: {
    //     callDetails: currentCallList
    //   }
    // });
    // store.dispatch({
    //   type: Types.INCOMING_CALL_POPUP,
    //   payload: {
    //     status: true,
    //     incomingCallDetail: incomingDetails.incomingCallDetail
    //   }
    // });
  } catch (error) {
    // logInfo("CallTimer error is",error);
  }
};

export const getAllUSerList = async () => {
  await CoreServices.get("/get_all_user_list").then((response: any) => {
    if (response.data.statusCode === 200) {
      store.dispatch({
        type: Types.GET_CONTACT_LIST,
        payload: {
          isgetContact: true,
          allContactList: response.data.getAllUserList,
        },
      });
    }
  });
};

export const getParticularAgentuser = (arrayList: any, ext: any) => {
  return _.filter(arrayList, (item: any) => {
    return item.ext === ext;
  });
};

export const doResetValuesAndEmptyTheReducers = () => {
  store.dispatch({
    type: Types.SIDE_BAR_OVERLAY_SETTINGS,
    payload: {
      sideBarOverlaySettings: false,
    },
  });
  store.dispatch({
    type: Types.SETUP_EDIT,
    payload: {
      isEdit: false,
      editData: {},
      editDataName: "",
    },
  });
  store.dispatch(ChatConfigurtationActions.codeSnippet({ codeSnippet: "" }));

  store.dispatch(
    ChatConfigurtationActions.personalisation({
      font: "Arial (sans-serif)",
      position: "flex-start",
      roundedCorners: 25,
      chatIconShape: 24,
      chatHeaderColor: "#5B55FF",
      agentMessageColor: "#E3E4E5",
      customerMessageColor: "#E2E2FA",
      actionMessageColor: "#575CFF",
      uploadDocs: false,
      createContact: false,
      chatToVoice: false,
      chatToEmail: false,
      downloadStatus: false,
      conversationHistory: false,
      isDisplaySupportNumber: false,
      supportNumber: "",
      isWidgetUnbranding: true,
      isCallUsIcon: false,
      isSendCallBackReq: false,
    })
  );

  // store.dispatch({
  //   type: Types.PERSONALIZATION,
  //   payload: {
  //     font: "Arial (sans-serif)",
  //     position: "flex-start",
  //     roundedCorners: 25,
  //     chatIconShape: 24,
  //     chatHeaderColor: "#5B55FF",
  //     agentMessageColor: "#E3E4E5",
  //     customerMessageColor: "#E2E2FA",
  //     actionMessageColor: "#FA6E8F",
  //     uploadDocs: false,
  //     createContact: false,
  //     chatToVoice: false,
  //     chatToEmail: false,
  //     conversationHistory: false,
  //     isDisplaySupportNumber: false,
  //     supportNumber: "",
  //     isWidgetUnbranding: false,
  //     isCallUsIcon: false,
  //     isSendCallBackReq: false,
  //   },
  // });

  store.dispatch(
    ChatConfigurtationActions.basicChatSettings({
      title: "",
      description: "",
      callFlowId: {},
      callFlowName: "",
      chatIconLogo: "",
      domainArr: [],
    })
  );

  store.dispatch(ChatConfigurtationActions.autoResChatSettings({
    autoResChatSettings: {
      handoffMessage: 'Please wait while I connect you to an available agent',
      busyMessage: 'All our agents are busy at the moment. We will connect you shortly. You could choose to wait or leave your name, email ID and phone number with us, and we will get back to you',
      isBusyCallbck: false,
      busyCallbckMsg: 'please leave us your name & email',
      unavilableMessage: 'All our agents are unavailable at the moment. Please leave your name, email address, and number and we will get back to you',
      isUnavailableCallbck: false,
      UnavailableCallbckMsg: 'please leave us your name & email',
      businessMessage: 'Our agents are only available between <start time> and <end time>. Please leave your name, phone number and email ID and we will get back to you!',
      isBusinessCallbck: false,
      businessCallbckMsg: 'please leave us your name & email',
      chatInactivity: 5,
      chatInactivityMsg: 'Are we still Connected!!',
      chatOtherInactivity: 0,
      chatOtherInactivityMsg: 'Are we still Connected!!',
      chatTimeout: 2,
      chatTimeoutMsg: "I'm ending this chat session now. Thanks for contacting us. Please feel free to get back to us for any further queries and assistance! Have a great day! Bye!",
      isenableTracker: false,
      trackerType: '',
      trackerName: '',
      trackerDelay: 1,
      trackerMsg: ''
    }
  }))
  // store.dispatch({
  //   type: Types.BASIC_CHAT_SETINGS,
  //   payload: {
  //     title: "",
  //     description: "",
  //     callFlowId: {},
  //     callFlowName: "",
  //     chatIconLogo: "",
  //     domainArr: [],
  //   },
  // });

  store.dispatch(
    ChatConfigurtationActions.primaryForm({
      primaryForm: [],
      prechatForm: false,
    })
  );

  // store.dispatch({
  //   type: Types.PRIMARY_FORM,
  //   payload: {
  //     primaryForm: [],
  //     prechatForm: false,
  //   },
  // });
};

let enableArrQueueList: any = [];
let enableArrSkillList: any = [];
let enableArrRoutingList: any = [];
let queueListArr: any = [];
let routingListArr: any = [];
let skillListArr: any = [];

export const sortEnableQueueListArray = () => {
  enableArrQueueList = [];
  const InitialSetupReducer: InitialSetupState = store.getState().initialSetupReducer;
  for (let i = 0; i < InitialSetupReducer.queueList.length; i++) {
    if (InitialSetupReducer.queueList[i].status === 1) {
      enableArrQueueList.push(InitialSetupReducer.queueList[i]);
    }
  }
  store.dispatch({
    type: Types.QUEUE_LIST_ENABLE,
    payload: {
      EnableQueueList: enableArrQueueList,
    },
  });
};
export const sortEnableSkillListArray = () => {
  enableArrSkillList = [];
  const InitialSetupReducer: InitialSetupState = store.getState().initialSetupReducer;
  for (let i = 0; i < InitialSetupReducer.skillmanagementList.length; i++) {
    if (InitialSetupReducer.skillmanagementList[i].status === 1) {
      enableArrSkillList.push(InitialSetupReducer.skillmanagementList[i]);
    }
  }
  store.dispatch({
    type: Types.SKILL_MANAGEMENT_ENABLE,
    payload: {
      enableSkillmanagementList: enableArrSkillList,
    },
  });
};

export const sortEnableRoutingProfileList = () => {
  const InitialSetupReducer: InitialSetupState = store.getState().initialSetupReducer;

  enableArrRoutingList = [];

  for (let i = 0; i < InitialSetupReducer.routingListTableData.length; i++) {
    if (InitialSetupReducer.routingListTableData[i].status === 1) {
      enableArrRoutingList.push(InitialSetupReducer.routingListTableData[i]);
    }
  }
  store.dispatch({
    type: Types.ROUTING_PROFILE_ENABLE,
    payload: {
      routingProfileEnableList: enableArrRoutingList,
    },
  });
};

export const routingListOrganiseFunc = (apiData: any) => {
  routingListArr = [];

  for (let data of apiData) {
    routingListArr.push({
      rid: data?.rid,
      routingname: data?.routing_prof_name,
      routingmethod: data?.routingMethod,
      linkedqueues: data?.No_of_linkedqueue,
      noofagent: data?.no_of_agent,
      status: data?.status,
    });
  }
  store.dispatch({
    type: Types.ROUTING_PROFILE_DATA,
    payload: {
      routingListTableData: routingListArr,
      routingListConstantData: routingListArr,
    },
  });
  sortEnableRoutingProfileList();
};

export const queueListOrganiseFunc = (value: any) => {
  queueListArr = [];
  for (let list of value) {
    queueListArr.push({
      name: list?.name,
      description: list?.description,
      OutboundCallerId: list?.OutboundCallerId,
      outBoundNumber: list.outBoundNumber,
      maxCallHandlingTimeMM: list.maxCallHandlingTimeMM,
      maxCallHandlingTimeSS: list.maxCallHandlingTimeSS,
      callWrapUpTime: list.callWrapUpTime,
      businessHours: list.hours_of_operation,
      outBoundCallStatus: list.outBoundCallStatus,
      audio: list.settingAudio,
      announcement: list.announcement,
      maximumCallers: list.maximumCallers,
      maximumWaitTime: list.maximumWaitTime,
      qid: list.qid,
      status: list.status,
    });
  }
  store.dispatch({
    type: Types.QUEUE_LIST,
    payload: {
      queueList: queueListArr,
    },
  });
  sortEnableQueueListArray();
};

export const skillListOrganiseFunc = (skillresultData: any) => {
  skillListArr = [];
  for (let skilldata of skillresultData) {
    skillListArr.push({
      skill_name: skilldata?.skill_name ? skilldata?.skill_name : "-",
      skill_description: skilldata?.skill_description,
      sid: skilldata?.sid,
      no_of_agnt_sk: skilldata?.no_of_agnt_sk,
      status: skilldata?.status,
    });
  }
  store.dispatch({
    type: Types.SKILL_MANAGEMENT,
    payload: {
      skillmanagementList: skillListArr,
    },
  });
  sortEnableSkillListArray();
};

export const MapAgentTrackerData = (dataValue: any, roleId: any) => {
  let result = mapAPIData(dataValue, roleId);
  return result;
};
const mapAPIData = (apiData: any, roleId: any) => {
  const mappedData = [];
  for (let data of apiData) {
    if (PRIVILLEGED_ROLES.includes(roleId) && [...PRIVILLEGED_ROLES, ROLES.SUPERVISOR_ROLE_ID].includes(data?.roleid?.toString())) {
      if (![ROLES.ADMIN_ROLE_ID, ROLES.SUPERVISOR_ROLE_ID].includes(roleId)) continue;
    }
    mappedData.push({
      stateTimer: data?.stateTimer,
      Timer: getCallTimeFromTimestamp(data?.stateTimer),
      statusName: data?.statusName,
      name: data?.UserName,
      workStatus: data?.status,
      voice: data?.voice,
      sms: data?.sms,
      socialMedia: data?.socialMedia,
      chat: data?.chat,
      email: data?.email,
      emailId: data?.emailId,
      ext: data?.ext,
      callType: data?.callType ?? "Call",
      sessionId: data?.currentSession,
      domainId: data?.domainId,
    });
  }
  return mappedData;
};

export const getCallTimeFromTimestamp = (time: any) => {
  let day: any = new Date().toLocaleString("en-GB", { timeZone: 'UTC' });
  let day2: any = new Date(time * 1000).toLocaleString("en-GB", { timeZone: 'UTC' });
  let diff: any = new Date(day).getTime() - new Date(day2).getTime();
  if (diff < 658066000) {
    let day3: any = new Date(Math.abs(Math.abs(diff) - 152000)).toLocaleString("en-GB", { timeZone: 'UTC' }); // 02:27 => 147000
    return day3.slice(-8);
  } else {
    return "00:00:00";
  }
}
/*
export const getCallTimeFromTimestamp = (time: any) => {
  // const oldDate: any = moment(Number(time)*1000).format('x');
  // const currentDate: any = moment().format('x');
  // const diff = currentDate - oldDate;
  // return diff;

  let difference = new Date().getTime() - new Date(parseInt(time) * 1000).getTime();
  let daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  difference -= daysDifference * 1000 * 60 * 60 * 24;

  let hoursDifference = Math.floor(difference / 1000 / 60 / 60);
  difference -= hoursDifference * 1000 * 60 * 60;

  let minutesDifference = Math.floor(difference / 1000 / 60);
  difference -= minutesDifference * 1000 * 60;

  let secondsDifference = Math.floor(difference / 1000);

  let hours: any = hoursDifference <= 9 ? `0${hoursDifference}` : hoursDifference;
  let minutes: any = minutesDifference <= 9 ? `0${minutesDifference}` : minutesDifference;
  let seconds: any = secondsDifference <= 9 ? `0${secondsDifference}` : secondsDifference;
  return hours + ":" + minutes + ":" + seconds;
};*/
//${minutesDifference <= 9 ? 0 + minutesDifference : minutesDifference}
//${secondsDifference <= 9 ? 0 + secondsDifference : secondsDifference}

// var duration = moment.duration(diffTime * 1000, 'milliseconds');
// var interval = 1000;

// setInterval(function () {
//   duration = moment.duration(duration - interval, 'milliseconds');
//   $('.countdown').text(duration.hours() + ":" + duration.minutes() + ":" + duration.seconds())
// }, interval);

// export const signOut = async (navigate: any, dispatch:any) => {
//   let cookieData: any = Cookie.get()
//   let LoginUserDetails: any = cookieData["accessToken"] && jwt_decode(cookieData["accessToken"]);
//   LoginService.logOut().then((response: any) => {
//     if (response.data.statusCode === 200) {
//       let updatedata = {
//         isVoice: 0,
//         isVoiceCallTransfer: 0,
//         isChat: 0,
//         isChatTransfer: 0,
//         isEmail: 0,
//         isEmailTransfer: 0,
//         stateTime: Math.floor(Date.now() / 1000),
//         statusName: "Offline",
//       };
//       CoreServices.put(updatedata, `/update_agent_status_value/${cookieData["userEmail"]}`).then((value: any) => {
//         if (value && value.data.statusCode === 200) {
//           store.dispatch({
//             type: Types.USER_LOGOUT,
//           });
//           Cookie.clear();
//           navigate("/login");
//           localStorage.clear();
//           sessionStorage.clear();
//           dispatch(
//             shortcutKeyActions.propsValue({
//               logOut: false,
//             })
//           );

//           callChatService.io.emit("updatestate", {
//             userstatedata: {
//               domainId: LoginUserDetails?.domainId,
//               isVoice: 0,
//               isVoiceCallTransfer: 0,
//               isChat: 0,
//               isChatTransfer: 0,
//               isEmail: 0,
//               isEmailTransfer: 0,
//               stateTime: Math.floor(Date.now() / 1000),
//               statusName: "Offline",
//             },
//             email: LoginUserDetails?.Email,
//           });
//           callChatService.destroy();
//         }
//       });

//       ////bharath

//       const date = new Date();
//       const uuid = GetItemFromStorage("uuid");
//       const body = {
//         logOutTimestamp: date.getTime(),
//         logInSessionId: uuid,
//       };

//       CoreServices.put(body, `/update_login_session_history`)
//         .then((res: any) => {
//           if (res.data.statusCode === 200) {
//           }
//         })
//         .catch((e: any) => console.error(e));
//     }
//   })

// };

export function isJSON(str: any) {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
}
export const getdateFormat = (date: any) => {
  var dateRes: any = "";
  dateRes = moment(date).format('hh:mm A')
  return dateRes;
}

export const sleep = async (ms: any) => {
  return new Promise(
    resolve => setTimeout(resolve, ms)
  )
}

export const getAuthorizationUrl = (connectorsName: any) => {

  let ccaasDomain = window?.location?.origin;
  let endDomain = ccaasDomain?.split('.')?.pop();

  let authorizationUrl = '';
  switch (connectorsName.toLowerCase()) {
    case 'outlook':
    case 'google':
    case 'calendly':
    case 'googlesheet':

      authorizationUrl = `${config().CONNECTORS_API_BASE_URL}/calendar/v1/${connectorsName.toLowerCase()}/login?domain=${endDomain}`;
      SetItemInStorage('selectedConName', connectorsName);

      break;

    default:

      authorizationUrl = `${config().CONNECTORS_API_BASE_URL}/${connectorsName.toLowerCase()}/v1/login?domain=${endDomain}`;
      connectorsName = connectorsName.replace('/', '_');
      SetItemInStorage('selectedConName', connectorsName);

      break;
  }

  const windowFeatures = "left=350,top=200,width=1300,height=700,toolbar=0,location=0,status=0,menubar=0,scrollbars=yes,resizable=yes,"
  window.open(
    authorizationUrl,
    "ccaaswindow",
    windowFeatures,
  );

}

export const getModulesList = async (connectorData: any) => {
  return await ConnectorService.crmGetModules(connectorData.conId).then((data: any) => {
    return data;
  }).catch((err: any) => {
    console.log("getModulesList err--------------", err);
  })
}

export const getSubModulesList = async (moduleData: any) => {
  return await ConnectorService.crmGetSubMod(moduleData.modId).then((data: any) => {
    return data;
  }).catch((err: any) => {
    console.log("getSubModulesList err--------------", err);
  })
}

export const getApiDetail = async (subModData: any) => {
  return await ConnectorService.crmGetApiDetails(subModData).then((data: any) => {
    return data;
  }).catch((err: any) => {
    console.log("getApiDetail err--------------", err);
  })
}

export const updateKeywords = async (data: any) => {
  return await ConnectorService.crmUpdatekeywords(data).then((data: any) => {
    return data;
  }).catch((err: any) => {
    console.log("updateKeywords err--------------", err);
  })
}
export const getCrmParamsList = async (domainId: any, token: any, con_name: any) => {
  return await ConnectorService.crmGetParameters(token, con_name).then(async (data: any) => {
    if (data.statusCode === 200) {
      return data;
    } else if (data.statusCode === 401 && data.result.message === 'Session expired or invalid') {
      return refreshToken(domainId, token, con_name, getCrmParamsList)
    }
  }).catch((err: any) => {
    console.log("err--------------", err);
  })
}
export const getCompanyParamsList = async (domainId: any, token: any, con_name: any, con_id: any) => {
  return await ConnectorService.crmGetCompanyParameters(token, con_name, con_id).then(async (data: any) => {
    if (data.statusCode === 200) {
      return data;
    } else if (data.statusCode === 401 && data.result.message === 'Session expired or invalid') {
      refreshToken(domainId, token, con_name, getCrmParamsList)
    }
  }).catch((err: any) => {
    console.log("err--------------", err);
  })
}

export const connectorsSyncOnFunction = async (domainId: any, con_name: any, payload: any, token: any) => {

  let connectorName = (con_name.toLowerCase() == 'zendesk sell' || con_name.toLowerCase() == 'zendesk support') ? con_name.toLowerCase().replace(" ", "/") : con_name.toLowerCase();

  return await ConnectorService.post(`${connectorName}/v1/syncOn`, payload, token).then(async (data: any) => {
    if (data.statusCode === 200) {
      return data;

    } else if (data.statusCode === 401 && data.result.message === 'Session expired or invalid') {

      return NewRefreshToken(domainId, token, payload, con_name, connectorsSyncOnFunction);
    }
  }).catch((err: any) => {
    console.log("err--------------", err);
  })
}

export const getCcaasContactProp = async () => {
  return await ConnectorService.crmCcaasParameters().then((data: any) => {
    return data;
  }).catch((err: any) => {
    console.log("err--------------", err);
  });
}

export const getConnectorsSync = async (domainId: any) => {
  return await ConnectorService.getSyncDetails(domainId).then(async (data: any) => {
    return data;
  }).catch((err: any) => {
    console.log("get connectot suybc", err);
  });
}

export const getCcaasParameter = async () => {
  return await ConnectorService.crmCcaasParameters().then(async (data: any) => {
    return data;
  }).catch((err: any) => {
    console.log("get connectot suybc", err);
  });
}

export const getConnectorsDataSync = async (domainId: any, token: any, connector_name: any) => {
  try {
    return Promise.all([ConnectorService.getSyncDetails(domainId), ConnectorService.crmGetParameters(token, connector_name)]).then((data: any) => {
      if (data[1].statusCode === 401 && data[1].result.message === 'Session expired or invalid') {
        refreshToken(domainId, token, connector_name, getConnectorsDataSync)
      } else if (data[0].statusCode === 200) {
        return data;
      }
    }).catch((err: any) => {
      console.log("get connectot suybc", err);
    });
  } catch (error) {
    console.log(error)
  }
}

export const getConnectorsCompanyDataSync = async (domainId: any, token: any, connector_name: any, com_id: any) => {
  try {
    return Promise.all([ConnectorService.getSyncDetails(domainId), ConnectorService.crmGetCompanyParameters(token, connector_name, com_id)]).then((data: any) => {
      if (data[1].statusCode === 401 && data[1].result.message === 'Session expired or invalid') {
        refreshToken(domainId, token, connector_name, getConnectorsDataSync)
      } else if (data[0].statusCode === 200) {
        return data;
      }
    }).catch((err: any) => {
      console.log("get connectot suybc", err);
    });
  } catch (error) {
    console.log(error)
  }
}
export const refreshToken = async (domainId: any, token: any, con_name: any, callback: Function, xeroTenantId?: any) => {
  return await ConnectorService.getRefreshToken(domainId, token, con_name).then((data: any) => {
    return callback(domainId, data.token, con_name, xeroTenantId);
  });
}

export const NewRefreshToken = async (domainId: any, token: any, payload: any, con_name: any, callback: Function,) => {

  return await ConnectorService.getRefreshToken(domainId, token, con_name).then((data: any) => {
    return callback(domainId, con_name, payload, data.results.token);
  });
}

export const getJSON = function (url: any, callback: any) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'json';
  xhr.onload = function () {
    var status = xhr.status;
    if (status === 200) {
      callback(null, xhr.response);
    } else {
      callback(status, xhr.response);
    }
  };
  xhr.send();
};

export const imageFormat = ["PNG", "jpeg", "jpg", "svg", "gif", "webp", 'png', "jfif", "ico", "tiff", "jfif", "nef", "orf", "dib", "eps", "raw", "heif", "apng", "avif", "jif", "tif", "xbm", "heic", "arw", "image/png",
  "image/jpeg", "image/jpg", "image/gif", "image/jfif", "image/heif", "application/octet-stream", "image/svg", "image/webp", "image/gif", "image/svg+xml", "image"
];
export const zipFormats = ["zip", "arj", "cab", "cfs", "application/x-zip-compressed", "cpt", "dar", "dmg", "war", "kgb", "txz", "dd", "ear", "wim", "jar", "rar", "yz1", "application/x-gzip", "application/zip", "application/octet-stream", "application/x-zip-compressed",
  "application/x-zip-compressed", "multipart/x-zip", "application/x-rar-compressed", "application/octet-stream", "application/x-gzip"
];
export const mp3Formats = ["mp3", "mpga", "wma", "ogg", "aif", "aifc", "aiff", "m4a", "aac", "audio/aac", "audio/wav", "audio/wave", "wav", "audio/mpeg", "audio/mp3", "audio"];
export const allFormats = ["xls", "xlsx", "xla", "xlt", "xml", "pptm", "xlw", "xltm", "pptx", "xlam", "xll", "aac", "csv", "zip", "arj", "cab", "cfs", "cpt", "dar", "dmg", "war", "kgb", "txz", "dd", "ear", "wim", "jar", "rar", "yz1", "ppt", "potx", "potm", "ppam", "ppsx", "sldx", "m4a", "ppsm", "sldm", "pdf", "docx", "dot", "doc", "dotm", "txt", "wpd", "odt", "wbk", "docm", "dotx", "docb", "rtf", "prn", "dif", "slk", "wav", "mp3", "mpga", "wma", "ogg", "aif", "aifc", "aiff", "htm", "html", "audio/mp3"];

export const pdfFormats = ["pdf", "application/pdf", "file"];
export const imageFormatType = ["image/png", "image/jpeg", "image/jpg", "image/jfif", "image/svg", "image/webp", "image/gif", "image/svg+xml"];

export const videoFormat = ["mp4", "video/mp4", "video/webm", "video/quicktime", "mov", "3gp", "video/3gpp", "video/x-ms-wmv", "video/x-msvideo", "video/x-flv", "ogg", "ogx", "wmv", "webm", "flv", "avi", "video"];

export const excelFormats = ["xla", "xlam", "xls", "xlsb", "xlsm", "application/vnd.ms-excel",
  "xlsx", "application/vnd.google-apps.spreadsheet", "xlt",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xltm", "xltx", "xlw", "csv", "application/vnd.ms-excel", "xll",
  'XLSX', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"
];
export const pptFormats = ["ppt", "pptx", "pptm", "potx", "potm", "ppam", "ppsx", "ppsm", "sldx", "sldm ", 'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.template.macroEnabled.12',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
];
export const wordFormats = ["docx", "dot", "doc", "text/plain",
  "dotm", "txt", "wpd", "odt", "wbk", "docm", "dotx", "docb", "rtf", "prn", "dif", "slk", "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  "application/vnd.ms-word.document.macroEnabled.12",
  "application/vnd.ms-word.template.macroEnabled.12"
];

export const getLeadGeneration = () => {
  // let LoginUserDetails: any = token["accessToken"] && token["accessToken"] && jwt_decode(token["accessToken"]);

  CoreServices.get(`/get_lead_generation_domainId`).then((value: any) => {
    console.log(value.data.result[0], "valuevaluevaluevalue")
    if (value && value.data.statusCode === 200) {
      return value.data.result[0];
    }
  });
};

export const getPaymentintergation = (companyId: any, dispatch: any) => {

  try {
    CoreServices.get(`/get_payment_intergation/${companyId}`).then((res: any) => {
      if (res?.data?.statusCode === 200) {
        if (res?.data?.result?.length > 0) {
          dispatch(connectorsActions.allPaymentmethoad(res?.data?.result[0]))
        }
      }

    })
  } catch (error) {
    console.log(error, "get_donotdisturb_customer_request___ERROR")
  }
}


export const insertPaymentIntergation = (formData: any, type: any) => {

  const uuid: any = GetItemFromStorage(LocalStorage.USER_DETAILS);

  let data: any = {
    "tokenId": type?.tokenId,
    "paymentType": type?.type,
    "secretJson": JSON.stringify(formData),
    "companyId": uuid?.companyId,
  }

  console.log(data, "uuiduuiduuid")


  CoreServices.post(data, `/insert_payment_intergation`)
    .then((resp: any) => {
      console.log(resp, "0p0p0p0p0p")
      // notification.info({
      //   message: `Payment updated successfully`,
      //   placement: "topRight",
      //   className: "toastNotification success"
      // });
      successNotify("Payment updated successfully")

    })
    .catch((err: any) => {

    });

}



export const deletePaymentIntergation = async (list: any) => {
  try {
    const res = await CoreServices.delete(`/delete_payment_intergation/${list.tokenId}`)
    if (res.data.statusCode === 200) {
      // notification.info({
      //   message: `Payment removed successfully`,
      //   placement: "topRight",
      //   className: "toastNotification success"
      // });
      successNotify("Payment removed successfully")
      return res;
    }
  } catch (error) {
    console.log('Form validation error:', error);
  }
}

export const UpdateChatTourFlag = async (data: any) => {
  try {
    const res = await CoreServices.post(data, `/update_onboard_user_flag`)
    if (res.data.statusCode === 200) {

    }
  } catch (error) {
    console.log('Form validation error:', error);
  }
}


export const xeroParameter = async (domainId: any, token: any, con_name: any, tenantId: any,) => {

  return await ConnectorService.xeroGet('xero/v1/parameters', token, tenantId).then(async (data: any) => {
    if (data.statusCode === 200) {
      return data;
    } else if (data.statusCode === 401 && data.result.message === 'Session expired or invalid') {
      refreshToken(domainId, token, con_name, xeroParameter, tenantId)
    }
  }).catch((err: any) => {
    console.log("err--------------", err);
  })
}

export const insertUpdateAgentAssist = (data: any) => {

  const { currentSession }: any = stores.getState().chatReducer;
  const { UserID } = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const { isUpdate } = data;
  let body: any = {
    domainId: currentSession?.domainId,
    HistoryId: null,
    DurationHistoryId: null,
    AssistMsg: data.AssistMsg,
    NoOfUsedAssistMsg: data.NoOfUsedAssistMsg,
    totalNoOfassist: data.totalNoOfassist,
    ChannelType: "",
    userId: UserID,
    isUpdate: isUpdate
  };


  if (currentSession?.ChatHistoryId) {
    body = {
      ...body,
      HistoryId: currentSession?.ChatHistoryId,
      DurationHistoryId: currentSession?.ChatDurationHistoryId,
      ChannelType: "Chat"
    }
  } else if (currentSession?.CallHistoryId) {
    body = {
      ...body,
      HistoryId: currentSession?.CallHistoryId,
      ChannelType: "Call"
    }
  } else if (currentSession?.EmailHistoryId) {
    body = {
      ...body,
      HistoryId: currentSession?.EmailHistoryId,
      ChannelType: "Email"
    }
  } else if (currentSession?.SMSHistoryId) {
    body = {
      ...body,
      HistoryId: currentSession?.SMSHistoryId,
      ChannelType: "Sms"
    }
  } else if (currentSession?.FacebookHistoryId) {
    body = {
      ...body,
      HistoryId: currentSession?.FacebookHistoryId,
      ChannelType: "Facebook"
    }
  } else if (currentSession?.InstagramHistoryId) {
    body = {
      ...body,
      HistoryId: currentSession?.InstagramHistoryId,
      ChannelType: "Instagram"
    }
  } else if (currentSession?.WhatsappHistoryId) {
    body = {
      ...body,
      HistoryId: currentSession?.WhatsappHistoryId,
      DurationHistoryId: currentSession?.WhatsappDurationHistoryId,
      ChannelType: "Whatsapp"
    }
  }
  if (body?.ChannelType && body?.ChannelType !== '') {
    callChatService.agentaAssistInsert(body);
  }
}


export const assignNewSkillsToAgent = (data: any) => {
  try {
    const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const body = {
      HistoryId: data?.ChatHistoryId,
      ChatDurationHistoryId: data?.ChatDurationHistoryId,
      channelType: "Chat",
      domainId: data?.domainId,
      ext: LoginCcaasUserDetails?.ext
    }
    axios.post('https://scraping.worktual.co.uk/auto_skill_assigning', body).then(async (res: any) => {
      if (res?.data?.status_code === 200 && res?.data?.skills?.length > 0) {

        const addSkillData: any = typeof LoginCcaasUserDetails?.addSkill === 'string' ? JSON.parse(LoginCcaasUserDetails?.addSkill) : []
        res?.data?.skills?.map((list: any) => {
          addSkillData?.push({ "value": list })
        })
        const payload = {
          add_skill: addSkillData,
          emailId: LoginCcaasUserDetails?.emailId,
          domain_id: LoginCcaasUserDetails?.domainId,
          ext: LoginCcaasUserDetails?.ext
        }

        await ApiServices.put(COREURL, "/update_user", payload)
          .then((response: any) => response)
          .catch((error: any) => error);

        const payloadForNotification = {
          uuid: uuidv4(),
          toUser: 200,
          notificationMsg: `${res?.data?.skills[0]} skill is assigned to ${LoginCcaasUserDetails?.UserName}`,
          channelType: 'Chat',
          markAsRead: 1,
          type: 'Skill Update'
        }
        await ApiServices.post(CALLURL, "/insert_notificationmsg", payloadForNotification)
          .then((response: any) => response)
          .catch((error: any) => error);
      }
    }).catch((err: any) => { console.log("err") })
  } catch (err) {
    console.log(err)
  }
}

export const dispositionValidationByAI = (data: any, dispositionName: any, customerData: any) => {
  try {
    const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const body = {
      HistoryId: data?.ChatHistoryId,
      ChatDurationHistoryId: data?.ChatDurationHistoryId,
      channelType: "Chat",
      domainId: data?.domainId,
      ext: LoginCcaasUserDetails?.ext,
      agent_status: dispositionName
    }
    axios.post('https://scraping.worktual.co.uk/disposition_status_check', body).then(async (res: any) => {
      if (res?.data?.status_code === 200 && res?.data?.disposition_status === 'unmatched') {
        const payload = {
          uuid: uuidv4(),
          toUser: 200,
          notificationMsg: `Status mismatch updated by ${LoginCcaasUserDetails?.UserName} during interaction with ${data?.calledPersonDetails !== null && data?.calledPersonDetails?.firstName !== "" && data?.calledPersonDetails?.firstName !== null && data?.calledPersonDetails?.firstName !== undefined && data?.calledPersonDetails?.lastName !== "" && data?.calledPersonDetails?.lastName !== undefined && data?.calledPersonDetails?.lastName !== null
            ? `${data.calledPersonDetails?.firstName} ${data.calledPersonDetails?.lastName}`
            : data?.calledPersonDetails != null && data?.calledPersonDetails?.firstName !== "" && data?.calledPersonDetails?.firstName !== undefined && data?.calledPersonDetails?.firstName !== null
              ? `${data?.calledPersonDetails?.firstName}`
              : customerData && customerData?.name ? customerData?.name : "New customer"}.`,
          channelType: 'Chat',
          markAsRead: 1,
          type: 'Wrong disposition update'
        }
        await ApiServices.post(CALLURL, "/insert_notificationmsg", payload)
          .then((response: any) => response)
          .catch((error: any) => error);
      }
    }).catch((err: any) => { console.log("err") })
  } catch (err) {
    console.log(err)
  }
}


export const summarySubjectHandler = async (payload: any, dispatch: any, type: number) => {
  try {
    dispatch(ChatActions.setAiSummaryStatus(true));
    const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetails;
    const { currentSession, sessionList }: any = stores.getState().chatReducer;
    const contactList: any = stores.getState().contactListForAgent;
    const agentWorkSpaceHistory = stores.getState().chatReducer?.agent_work_space_history
      ?.filter((item: any) => item?.sessionId === currentSession?.sessionId);
    const cookieKey = [...agentWorkSpaceHistory].reverse().find((item: any) => item?.isCustomer)?.cookieKey;

    let data = {
      HistoryId: payload?.ChatHistoryId,
      ChatDurationHistoryId: payload?.ChatDurationHistoryId,
      channelType: payload?.isVideoChannel ? 'video' :'Chat',
      domainId: payload?.domainId,
      ext: parseInt(LoginCcaasUserDetails?.ext),
      companyId: LoginUserDetails.companyId,
      meetingId: currentSession?.sessionId ,
      agentId: LoginCcaasUserDetails?.UserID
    };
          
    if (data?.channelType !== 'video') {
      let nlpSummaryBody = {
        'user_id_data': cookieKey,
        'session_id': currentSession?.sessionId,
        'channelType': data?.channelType,
      }
      getSummaryConvo(nlpSummaryBody)
    }

    const responsed = await CallServices.post(data, "/ai_summary_subject")
      .catch((error: any) => {
        // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
        dispatch(ChatActions.setAiSummaryStatus(false))
      });
    const response = responsed?.data?.response
    if (response) {
      let subject = response.subject?.trim() || null
      let summary = response.summary?.trim() || null
      let disposition = response.disposition?.trim() || null
      if (disposition && type !== 1) {
        const dispositionData = contactList?.dispositionTagList?.filter((list: any) => list?.dispositionName === disposition);
        const data = { key: dispositionData[0] }
        dispatch(dispositionSliceActions.setDisposition(data))
      }
      if (subject) {
        dispatch(dispositionSliceActions.setSubject(subject));
      }
      if (summary) {
        dispatch(dispositionSliceActions.setSummary(summary));
      }
      // dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: subject, aiSummary: summary, isChatEnded: 1 }));
      if(!payload?.isVideoChannel) dispatch(ChatActions.setDispositionAISummary({
        sessionId: currentSession?.sessionId,
        aiSubject: subject,
        aiSummary: summary,
        isChatEnded: 1
      }));
      const addedSessionList = sessionList?.map((list: any) => {
        if (list?.ChatHistoryId === payload?.ChatHistoryId) {
          return {
            ...list,
            aiSubject: subject,
            aiSummary: summary,
            isChatEnded: 1
          };
        }
        return list;
      });
      dispatch(ChatActions.meetSessionList(addedSessionList))
    }
    // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
    dispatch(ChatActions.setAiSummaryStatus(false))
  } catch (error) {
    // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
    dispatch(ChatActions.setAiSummaryStatus(false))
    return null;
  }
};

export const summarySubjectHandlerForCall = async (sessionID: any, dispatch: any, type: number) => {
  try {
    dispatch(ChatActions.setAiSummaryStatus(true))
    const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const { currentSession, sessionList }: any = stores.getState().chatReducer;
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetails;
    const sessionData = sessionList?.filter((list: any) => list?.sessionId === sessionID);
    const contactList: any = stores.getState().contactListForAgent;
    const payload = sessionData?.[0]
console.log('currentSession>>>>>>>>>>>>>>>>>>>>>>>>>>>',currentSession)
    let data = {
      HistoryId: payload?.CallHistoryId,
      ChatDurationHistoryId: 0,
      channelType: 'Call',
      domainId: payload?.domainId,
      ext: parseInt(LoginCcaasUserDetails?.ext),
      companyId: LoginUserDetails.companyId
    };

    let nlpSummaryBody = {
      'user_id_data': currentSession?.calledNumber,
      'session_id': currentSession?.sessionId,
      'channelType': 'Call',
    }
    getSummaryConvo(nlpSummaryBody)

    const responsed = await CallServices.post(data, "/ai_summary_subject")
      .catch((error: any) => {
        dispatch(ChatActions.setAiSummaryStatus(false));
        console.log(error)
      });
    const response = responsed?.data?.response
    if (response) {
      let subject = response.subject?.trim() || ""
      let summary = response.summary?.trim() || ""
      let disposition = response.disposition?.trim() || ""

      if (disposition && type !== 1) {
        const dispositionData = contactList?.dispositionTagList?.filter((list: any) => list?.dispositionName === disposition);
        const data = { key: dispositionData[0] }
        dispatch(dispositionSliceActions.setDisposition(data))

      }
      if (subject) {
        dispatch(dispositionSliceActions.setSubject(subject));
      }
      if (summary) {
        dispatch(dispositionSliceActions.setSummary(summary));
      }
      if (currentSession?.sessionId === sessionID) {
        dispatch(ChatActions.currentChatSession({ ...currentSession, aiSubject: subject, aiSummary: summary, callDispositionOpen: true }));
      }
      const addedSessionList = sessionList?.map((list: any) => {
        if (list?.sessionId === sessionID) {
          return {
            ...list,
            aiSubject: subject,
            aiSummary: summary,
            callDispositionOpen: true
          };
        }
        return list;
      });
      dispatch(ChatActions.meetSessionList(addedSessionList))
      dispatch(ChatActions.setAiSummaryStatus(false))
    }
    //dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
  } catch (error) {
    dispatch(ChatActions.setAiSummaryStatus(false))
    return null;
  }
};

export const insertnotes = (currentSession: any) => {

  const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  let historyId =
    currentSession?.channelType === "Email"
      ? currentSession?.EmailHistoryId
      : currentSession?.channelType === "Sms"
        ? currentSession?.SMSHistoryId
        : (currentSession?.channelType === "Chat" || currentSession?.ChatHistoryId)
          ? currentSession?.ChatHistoryId
          : currentSession?.channeltype === "Call"
            ? currentSession?.CallHistoryId
            : currentSession?.channelType === "Instagram"
              ? currentSession?.InstagramHistoryId
              : currentSession?.channelType === "Facebook"
                ? currentSession?.FacebookHistoryId
                : currentSession?.channelType === "Whatsapp"
                  ? currentSession?.WhatsappHistoryId
                  : null;


  const body = {
    historyId: historyId,
    coid: currentSession?.calledPersonDetails?.coid,
    channelType: currentSession?.channelType,
    agentId: loginUserCcaasDetail?.UserID,
    notes: currentSession?.notes,

  };
  console.log("insert_update_interaction_notes", currentSession)
  CoreServices.post(body, "/insert_update_interaction_notes").then((res: any) => {
    if (res.data.statusCode === 200) {
      console.log("INSERTEDDDDDDDDDDDDDDEDDDDDDDDDDDD")
    }
  });
  console.log("currrrenntttttt", currentSession)

  console.log("Chat has ended. Call your logic here.");
  // Your logic here
};
export const getCallBlastAutoAnswer = (dispatch: any) => {
  try {
    CallServices.get("/get_callBlast_auto_answer").then((res: any) => {
      if (res.data.statusCode == 200) {
        const response = res.data.result?.[0]
        if (response?.length > 0 && res.data.statusCode == 200) {
          dispatch(outboundCampaignSliceAction.setAutoAnswer(response?.[0]?.isAutoAnswer ?? 0));
        } else {
          CallServices.post({ isAutoAnswer: 0 }, "/insert_update_callBlast_auto_answer").then((res: any) => {
            if (res.data.statusCode == 200) {
              dispatch(outboundCampaignSliceAction.setAutoAnswer(response?.[0]?.isAutoAnswer ?? 0));

            }
          })
        }
      }
    })
  } catch (error) {
    console.log("getCallBlastAutoAnswer", error)
  }
}



export const detectCurrentZone_Time = () => {
  try {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const findgetTime = countryTimezones.find((i: any) => i.label.includes(userTimeZone))
    const getTime = findgetTime?.label?.split('GMT ')[1]
    return getTime || null
  } catch (error) {
    return null
  }
}


export const aiGrouping = (data: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      axios.post('https://nlp.worktual.co.uk/merge_ticket', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        resolve(response.data)
      }).catch((error) => {
        reject(error);
        console.log(error.response);
      });
    } catch (err) {
      console.log(err);
      reject(err);
    }
  }
  )
}


export const IndianPhPattern = /^(\+\d{12}|\d{10})$/;
export const GlobelPhPattern = /^\d{8,15}$/;
export const FBIdPattern = /^[a-zA-Z0-9._]{5,50}$/;

export const UKPostalCode = /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s?\d[A-Za-z]{2}$/;
export const IndianPostalCode = /^\d{6}$/;

// export const postalCodeValidation = (value :any)=>{
//   try {
//     if(window.location.origin === 'https://ccaas.worktual.in'){
//       return IndianPostalCode.test(value)
//     }
//     else if(window.location.origin === 'https://ccaas.worktual.co.uk'){
//       return UKPostalCode.test(value)
//     }
//     return  /^[a-zA-Z0-9-]{3,20}$/.test(value)
//   } catch (error) {
//     console.log(error)
//   }
// }

export const indianPhoneCheck = (value: any) => {
  try {
    if (window.location.origin === 'https://ccaas.worktual.in') {
      return IndianPhPattern.test(value)
    }
    return GlobelPhPattern.test(value)

  } catch (error) {
    console.log(error)
  }
}
export const getTime = async (dispatch: any) => {
  try {
    const time = await CallServices.get("/time")
    // setServerTimer(time?.data?.serverTime ?? 0)
    dispatch(
      queueTrackerActions.updatetTimer(time?.data?.serverTime ?? 0)
    );
  } catch (error) {
    console.log('time error', error)
  }
}


const restrictedModules: any = {
  13490: ['Disposition/regenerate'],
  7179: ['Disposition/regenerate'],
  19726: [
    'Menubar/Ticket',
    'KeyboardShortcuts',
    'Contact/profile',
    'Contact/Create',
    'Leaderboard/admin',
    'CompareDashboard',
    'Dashboard/admin',
    'Dashboard/Supervisor',
    'Dashboard/agent',
    'Reports/AgentAnalytics',
    'Reports/QueueAnalytics',
    'settings/chatlimit',
    'settings/email',
    'settings/sms',
    'settings/whatsapp',
    'settings/facebook',
    'settings/instagram',
    'settings/customerSatisfaction',
    'settings/leadIntegration',
    'settings/conversationTrigger',
    'settings/connectors',
    'settings/apiconfiguration',
    'settings/privateapp',
    'settings/publicapp',
    'settings/paymentmethods',
    'settings/usermanagement/chatlimit',
    'settings/usermanagement/channels',
    'settings/contactsettings/socialmedia',
    'Reports/aibotAnalytics',
    'Reports/aibotReports',
    'Reports/visitorInsights',
    'allActivity/viewinteraction',
    'Disposition/createTicket',
    'myactivity/ticketId',
    'allActivity/channelFilter',
    'assignActivity/channelFilter',
    'contact/smsemail',
    'Reports/channelReports',
    'settings/voice/createcallconfig',
    'scheduleReport',
    'costpercall',
    'speedometer',
    'Disposition/regenerate',
    'dashboard/SentimentalAnalysis',
    'dashboard/agentAssist',
    'myactivity/TransferredTo',
    'allactivity/viewinteration/transcription',
    'settings/csat',
    'allactivity/viewinteration/channelfilter',
    'allactivity/Sentimentscorefilter',
    'Dashboard/Supervisor/SentimentalAnalysis',
    'Dashboard/Supervisor/agentassist',
    'dashboard/agentandbot',
    'allActivity/allviewrefresh',
    'recordings/sentimentalScore',
  ],   // Company : Calvary Temple

  19465: [
    'Menubar/Ticket',
    'allActivity/viewinteraction',
    'Disposition/createTicket',
    'myactivity/ticketId'
  ],   // Company : Ogrelogic Solutions LLC

  18878: [
    'Menubar/Ticket',
    'allActivity/viewinteraction',
    'Disposition/createTicket',
    'myactivity/ticketId'
  ],   // Company : Cinimini By Theatre Concepts

}

export const restrictedDomainId = (names: any) => {
  try {
    const LoginUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const domainId: any = LoginUserDetails?.domainId;
    if (!domainId || !restrictedModules[domainId]) {
      return true
    }
    return !restrictedModules[domainId].includes(names)
  } catch (error) {
    return true
  }
}

export const CONTACT_CENTRE_PARENT_ID = {
  "STARTER": 32,
  "GROWTH": 141,
  "PRO": 33,
  "ENTERPRISE": 42
}
const restrictedModules_2: any = {
  // starter
  32 : [
    "Contact/integration",
    "Settings/dispositionstatus",
    "Settings/agentstatus",
    "Settings/customertag",
    "Settings/customertype",
    "Settings/callblast",
    "settings/customerSatisfaction",
    "settings/leadIntegration",
    "settings/conversationTrigger",
    "settings/connectors",
    "settings/apiconfiguration",
    "settings/privateapp",
    "settings/publicapp",
    "settings/paymentmethods",
    "settings/skillmanagement",
    "settings/webchatwidget",
    "settings/sms",
    "settings/facebook",
    "settings/whatsapp",
    "settings/instagram",
    "settings/chatlimit",
    'settings/recordSettings',
    'settings/multiLingual',
    "workspace/TransferredTo",
    "callTranscript",
    "workspace/agentAssist",
    'Reports/channelReports',
    "channelReport/Transfercall",
    "Analytics/agentanalyticsmain",
    "Analytics/queueanalytics",
    "Reports/aibotAnalytics",
    "Reports/aibotReports",
    'Reports/campaignReports',
    "Reports/visitorInsights",
    "Reports/outboundcampaignreports",
    "Chatflow",
    "channelReport/ACWtime",
    "channelReport/transferredcalls",
    "agentReport/CSATscore",
    "agentreport/feedaback",
    "KnowledgeBase",
    "internalChat/lastintactions",
    "speedometer",
    "workspace/notes",
    "allactivity/summary",
    // "Contact/quickActions",
    "comparedashboardfilter/Voice",
    "livedashboard/channelfilter",
    "agentDashboard/channelfilter",
    "summary/recommendation",
    "liveDashboard/session",
    "livedashboard/sentimental&responseRating",
    "livedashboard/wevisitor",
    "CompareDash/Dropdown",
    "aiChat",
    "voiceFlow/makeApiCall",
    "voiceFlow/checkCondition",
    "voiceFlow/voiceAuthentication",
    'Disposition/regenerate',
    'workspace/emotion',
    'smsactivity/autoassign',
    'routingprofile/concurrentchat',
    'usermanagement/channels',
    'usermanagement/ChatLimit', 
    'usermanagement/outboundcampaign',
    'channelreports/voice/Transferred',
    'channelreports/voice/Transfer',
    'channelreports/sms/transferredon',
    'agentreport/loginlogut/CustomTime',
    'agentemailreport/totalTransferred',
    'allactivity/viewinteration/transcription',
    "Dashboard/dynamicDash",
    "previousChatSummary",
    "voicechannel/virtualAgent",
    "workspace/internalChat",
    "contact/type",
    "workflow",
    "recording",
    "settings/contactsettings",
    "settings/videoconfig",
    "workspace/interaction",
    "livedashboard/outboundCampaignKey",
    // "settings/CreateQueue",
    // "settings/routingProfile",
    "transfer/call",
    "CompareDash/name",
    "sentimentalAnalysis",
    "settings/voice/CallFlowList",
    "internalChat",
    "voiceMail/Transcript",
    "workspace/TransferButton",
  ],

  // Growth
  141: [
    'Menubar/Ticket',
    'KeyboardShortcuts',
    'Contact/profile',
    'Contact/Create',
    'Leaderboard/admin',
    'CompareDashboard',
    'Dashboard/admin',
    'Dashboard/Supervisor',
    'Dashboard/agent',
    // 'Reports/AgentAnalytics',
    // 'Reports/QueueAnalytics',
    // 'settings/chatlimit',
    // 'settings/email',
    // 'settings/sms',
    // 'settings/whatsapp',
    // 'settings/facebook',
    // 'settings/instagram',
    // 'settings/customerSatisfaction',
    // 'settings/leadIntegration',
    // 'settings/conversationTrigger',
    // 'settings/connectors',
    // 'settings/apiconfiguration',
    // 'settings/privateapp',
    // 'settings/publicapp',
    // 'settings/paymentmethods',
    // 'settings/usermanagement/chatlimit',
    // 'settings/usermanagement/channels',
    // 'settings/contactsettings/socialmedia',
    'Reports/aibotAnalytics',
    'Reports/aibotReports',
    'Reports/visitorInsights',
    'allActivity/viewinteraction',
    'Disposition/createTicket',
    'myactivity/ticketId',
    // 'allActivity/channelFilter',
    'assignActivity/channelFilter',
    'contact/sms',
    // 'contact/email',
    // 'Reports/channelReports',
    'settings/voice/createcallconfig',
    'scheduleReport',
    'costpercall',
    'speedometer',
    'Disposition/regenerate',
    'dashboard/SentimentalAnalysis',
    'dashboard/agentAssist',
    'myactivity/TransferredTo',
    'allactivity/viewinteration/transcription',
    // 'settings/csat',
    'allactivity/viewinteration/channelfilter',
    'allactivity/Sentimentscorefilter',
    'Dashboard/Supervisor/SentimentalAnalysis',
    'Dashboard/Supervisor/agentassist',
    'dashboard/agentandbot',
    'allActivity/allviewrefresh',
    'recordings/sentimentalScore',
    'callTranscript',
    'workspace/agentAssist',
    // 'livedashboard/channelfilter',
    // 'agentdashboard/channelfilter',
    'summary/recommendation',
    'Contact/integration',
    // "Settings/dispositionstatus",
    // "Settings/agentstatus",
    // "Settings/customertag",
    // "Settings/customertype",
    // "Settings/callblast",
    "settings/skillmanagement",
    // "settings/webchatwidget",
    // "Analytics/queueanalytics",
    "Reports/outboundcampaignreports",
    // "Chatflow",
    "channelReport/ACWtime",
    "agentReport/CSATscore",
    "agentreport/feedaback",
    // "KnowledgeBase",
    "KnowledgeBase/addUrl",
    "internalChat/lastintactions",
    // "workspace/notes",
    // "agentDashboard/channelfilter",
    "liveDashboard/session",
    "livedashboard/sentimental&responseRating",
    "livedashboard/wevisitor",
    "CompareDash/Dropdown",
    "aiChat",
    "voiceFlow/makeApiCall",
    "voiceFlow/checkCondition",
    "voiceFlow/voiceAuthentication",
    'smsactivity/autoassign',
     'usermanagement/channels',
    'usermanagement/ChatLimit',
    // 'usermanagement/outboundcampaign',
     'dashboard/comparedashboard',
    'workspace/emotion',
    "Dashboard/dynamicDash",
    "previousChatSummary",
    "voicechannel/virtualAgent",
    "allactivity/Sentimentscorefilter",
    "campaign/aichat",
    "sentimentalAnalysis"
    // "livedashboard/outboundCampaignKey",
    ],
 
  // Pro
  33 : [
    // "Reports/aibotAnalytics",
    // "Reports/aibotReports",
    // "Knowledgebase/scrapping",
    // "Knowledgebase/qa",
    // "aiChat",
    // "voiceFlow/checkCondition",
    // "voiceFlow/makeApiCall",
    // "voiceFlow/voiceAuthentication",
    // "chatflow/carousel",
    // "chatflow/datePicker",
    // "chatflow/addFlow",
    // "chatflow/integration",
    // "chatflow/Payment",
    // "chatflow/checkCondition",
    // "chatflow/coupon",
    // "chatflow/randomise",
    //  "voicechannel/autoattendent",
    // "voicechannel/multilingualsupport",
    // "chatwidget/personalization&primaryform",
    // "dispositionstatus/create",
    // "agentStatus/create",
    // "agentStatus/customerTag",
    // "dispositionstatus/customerType",
    // "widgeticon/personalization",
    // "fontstyle/personalization",
    // "agentmessagecolour/personalization",
    // "actionmessagecolour/personalization",
    // "chatbackground/personalization",
    // "advancedsettings/uploaddocuments",
    // "advancedsettings/widgetlanguage",
    // "advancedsettings/emailtranscript",
    // 'usermanagement/outboundcampaign',\
    
    // -- New --

      // "workflow",
      'routingprofile/concurrentchat',
      "sentimentalAnalysis"

  
  ],
  //enterprise
  42: [
    "workflow",
    "KnowledgeBase/Hide",
    'routingprofile/concurrentchat',
    'voicechannel/virtualAgent',  // ====  virtual agent will show if servicePlan.Type_of_plan - condition directly writen in that flow
    'settings/VoiceConfiguration/callflow/Hide',
    "sentimentalAnalysis"
  ]
}

/**
 * 
 * Calvery - 19726;
 * POC - 19331
 * Calvary accounts team - 20441
 *  --------   USECASE : Ristricted & Allowded by Domain id   ---------
 * Calvery and POC have access on Growth plan but some modules will be diff from growth and clavary domain.
 * to avoid such issue, we will create a list of routes and modules that can be accessed by both Calvery and POC based on Domain Id.
 * 
*/

export const RistictedByDomain = [19726, 19331, 20441 ]
const RistictedDomain_Routes = [
  "callTranscript",
]

const AllowdedByDomain = [19726, 19331, 20441]
const AllowModules_domain = [
   "Reports/outboundcampaignreports",
   "Analytics/queueanalytics",
   "settings/webchatwidget",
   "Chatflow",
   "Analytics/agentanalyticsmain",
   "liveDashboard/session",
   "livedashboard/wevisitor",
   "Settings/callblast",
   'usermanagement/outboundcampaign',
   'channelReport/voice',

]

export const ruyabank = {
  domainId: 20342,
  
  allowedNewModules: [
     "workflow",
    'settings/VoiceConfiguration/callflow/Hide'
  ],
  restrictedNewModules: [
      "Chatflow"
  ]
}

export const hiveFertility = {
  domainId: 20649,
  
  allowedNewModules: [
     "Dashboard/dynamicDash",
     "workspace/agentAssist",
     "Disposition/regenerate",
     "KnowledgeBase/addUrl",
     "callTranscript",
     "speedometer",
     "allactivity/Sentimentscorefilter",
     "Reports/aibotAnalytics",
     "Reports/aibotReports",
     "Reports/visitorInsights",
     "allActivity/viewinteraction",
     "workspace/interaction",
     "livedashboard/channelfilter",
     "allActivity/channelFilter",
     "usermanagement/ChatLimit",
     "usermanagement/channels",
     "Reports/channelReports",
     "allactivity/viewinteration/transcription",
     "settings/skillmanagement",
     "sentimentalAnalysis",
     "dynamicDashboard/callbackrequest",
  ],
  restrictedNewModules : [
      "dynamicDashboard/callcost",
      "workspace/emotion"
  ]
}

export const blox = {
  domainId: 19879,
  
  allowedNewModules: [
     "workflow",
    'settings/VoiceConfiguration/callflow/Hide'
  ],
  restrictedNewModules: [
      "Chatflow"
  ]
}
export const kgjHospitals = {
  domainId: 20633,

  allowedNewModules: [
    "workflow",           // example
  ],

  restrictedNewModules: [
    "settings/Configuration/call",
    "settings/Configuration/email",
    "settings/Configuration/sms",
    "settings/Configuration/video",
    "reports/AdvancedReports",
    "settings/recordSettings",
    "Settings/callblast",
    "Recording",
    "callflow",
    "Reports/outboundcampaignreports",
    'dialPad/Hide'
  ]
};


// const AllowedProDomain = [19331]
// const AllowedPro = [
//    "Reports/aibotAnalytics",
//    "Reports/aibotReports",
// ]

const CHAT_BOX_RISTICT = [
  "Dashboard/dynamicDash"
]

export const hassAccess = (names : any)=>{
  try {
    let tokenData: any = Cookies.get();
    let Authorization: any = tokenData['ssoToken'] ?? "";

    if(Authorization){
      let LoginUserDetails: any = jwt_decode(Authorization);
      let parent_id = Number(LoginUserDetails?.parent_id);
      let product_id = Number(LoginUserDetails?.product_id);

      if(product_id === 15 && CHAT_BOX_RISTICT.includes(names)){
        return false
      }

      if( RistictedByDomain.includes(LoginUserDetails.domainId) && RistictedDomain_Routes.includes(names)){
        return false
      }
      if( AllowdedByDomain.includes(LoginUserDetails.domainId) && AllowModules_domain.includes(names)){
        return true
      }

      if(ruyabank.domainId == LoginUserDetails.domainId) {
        if(ruyabank.allowedNewModules.includes(names)){
          return true
        } else if (ruyabank.restrictedNewModules.includes(names)) {
          return false
        }
      }

      if(hiveFertility.domainId == LoginUserDetails.domainId) {
        if(hiveFertility.allowedNewModules.includes(names)){
          return true
        } else if (hiveFertility.restrictedNewModules.includes(names)) {
          return false
        }
      }

       if(blox.domainId == LoginUserDetails.domainId) {
        if(blox.allowedNewModules.includes(names)){
          return true
        } else if (blox.restrictedNewModules.includes(names)) {
          return false
        }
      }
      if (kgjHospitals.domainId == LoginUserDetails.domainId) {
        if (kgjHospitals.allowedNewModules.includes(names)) {
          return true;
        } else if (kgjHospitals.restrictedNewModules.includes(names)) {
          return false;
        }
      }
      
      // if( AllowedProDomain.includes(LoginUserDetails.domainId) && AllowedPro.includes(names)){
      //   return true
      // }
      if(!parent_id || !restrictedModules_2[parent_id]){
        return true
      }
      return !restrictedModules_2[parent_id].includes(names)
    } else {
      return true
    }
  } catch (error) {
    return true
  }
}

export const navigateToTicketing = () => {
  try {
    const host = window.location.host;
    let countryCode = '';
    const parts = host.split('.');
    if (parts.length > 2) {
      countryCode = parts[parts.length - 1]
    }
    console.log(">>>>>>>>",countryCode)
    if (process.env.REACT_APP_ENV === 'production') {
      switch (countryCode) {
        case 'uk': {
          window.open(
            "https://myaccount.worktual.co.uk/purchasemain",
            "_blank"
          );
          break;
        }
        case 'in': {
          window.open(
            "https://myaccount.worktual.in/purchasemain",
            "_blank"
          );
          break;
        }
        case 'com': {
          window.open(
            "https://myaccount.worktual.com/purchasemain",
            "_blank"
          );
          break;
        }
      }
    } else {
      window.open(
        "https://qa-myaccount.worktual.co.uk/purchasemain",
        "_blank"
      );
    }
  } catch (error) {
    console.log(error)
  }
}

export const formatDateTime = (timestamp: string) => {
  if (!timestamp) return '';
  const now = new Date();
  const notificationDate = new Date(timestamp);

  const diffInDays = differenceInDays(now, notificationDate);

  if (diffInDays === 0) {
    return 'Today';
  } else if (diffInDays === 1) {
    return 'Yesterday';
  } else if (diffInDays < 7) {
    return format(notificationDate, 'EEEE');
  } else {
    return format(notificationDate, 'MMMM d, yyyy');
  }
};

let lastBcHistoryId: any = null;

export const getMessageDetails = async (bcHistoryId: any, dispatch: any, setLoading: any) => {
  const LoginUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const shouldSetLoading = lastBcHistoryId !== bcHistoryId;

  if (shouldSetLoading) {
    setLoading?.(true);
  }
  lastBcHistoryId = bcHistoryId;

  try {
    const body = {
      bcHistoryId: bcHistoryId,
      AgentId: LoginUserDetails?.roleid == ROLES.AGENT_ROLE_ID ? LoginUserDetails?.UserID : null,
    };

    await CoreServices.post(body, '/get_broadcast_groupmsg')
      .then((response) => {
        const data = response?.data?.broadCastRes;
        if (response?.data?.statusCode === 200) {
          data?.forEach((item: any) => {
            item.bcHistoryId = bcHistoryId;
          });

          dispatch(ChatActions.setMessage({ new: true, message: [...data] }));

          if (data.length > 0) {
            const lastMsg = data[data.length - 1];
            const parsed = JSON.parse(lastMsg.message);
            dispatch(ChatActions.updateBroadcastGroupMessage({
              bcHistoryId: bcHistoryId,
              message: parsed.message,
              lastUpdated: parsed.sendTimestamp || Date.now(),
            }));
          } else {
            dispatch(ChatActions.updateBroadcastGroupMessage({
              bcHistoryId: bcHistoryId,
              message: '',
              lastUpdated: Date.now()
            }));
          }
        } else {
          dispatch(ChatActions.setMessage({ new: true, message: [] }));
          dispatch(ChatActions.updateBroadcastGroupMessage({
            bcHistoryId: bcHistoryId,
            message: '',
            lastUpdated: Date.now()
          }));
        }
      })
      .catch((error) => {
        dispatch(ChatActions.setMessage({ new: true, message: [] }));
        console.error("Error fetching internal chat:", error);
      });
    setLoading?.(false);
  } catch (error) {
    setLoading?.(false);
    console.log(error);
  } finally {
    setLoading?.(false);
  }
};

export const cleanHtml = (html: any) => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc.querySelectorAll('span.ql-cursor').forEach(el => el.remove());
    return doc.body.innerHTML;

  } catch (error) {
    console.log(error)
    return ''
  }
}


export const getFileSize = (size: number) => {
  try {
    if (!size)
      return size
    if (size >= 1024 * 1024) {
      const sizeInMB = (size / (1024 * 1024)).toFixed(1);
      return `${sizeInMB} MB`;
    } else if (size >= 1024) {
      const sizeInKB = (size / 1024).toFixed(1);
      return `${sizeInKB} KB`;
    } else {
      return `${size} bytes`;
    }
  } catch (error) {
    console.error('getFileSize error::', error)
  }
}

export const getSummaryConvo = (data: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json'
    };

    return axios
      .post(`${config().AGENT_SUMMARIZE_CONVO}`, data, { headers })
      .then(res => res?.data)
      .catch(() => ({ data: '' }));
  } catch (error) {
    console.log('error', error);
  }
};

export const openContactPage = () => {
  const host = window.location.host;
  const parts = host.split('.');
  const code = parts.length > 2 ? parts[parts.length - 1] : 'in';

  switch (code) {
    case 'uk':
      window.open('https://worktual.co.uk/contact/');
      break;
    case 'in':
      window.open('https://worktual.in/contact/');
      break;
    case 'com':
      window.open('https://worktual.com/contact/');
      break;
    default:
      window.open('https://worktual.in/contact/');
  }
};

export const findLoadableImageUrl = async (urls: (string | undefined | null)[]): Promise<string | null> => {
  try {
    for (const url of urls) {
      if (!url?.trim()) continue;

      const isLoadable = await new Promise<boolean>((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
      if (isLoadable) return url;
    }
    return null;
  } catch (error) {
    return null
  }
};


